import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vShow as _vShow, Transition as _Transition, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pgm-budget" }
const _hoisted_2 = {
  key: 0,
  class: "initial-loading-overlay"
}
const _hoisted_3 = { class: "loading-spinner" }
const _hoisted_4 = {
  key: 0,
  class: "budget-sidebar"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "sidebar-year-selector" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "year-display" }
const _hoisted_9 = { class: "year-value" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "sidebar-filter" }
const _hoisted_12 = { class: "filter-header" }
const _hoisted_13 = { class: "filter-buttons" }
const _hoisted_14 = { class: "sidebar-summary" }
const _hoisted_15 = { class: "summary-item revenue" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "summary-item expense" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "summary-header" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  class: "sidebar-labor-cost"
}
const _hoisted_22 = { class: "labor-cost-header" }
const _hoisted_23 = { class: "labor-cost-content" }
const _hoisted_24 = { class: "labor-cost-item standard" }
const _hoisted_25 = { class: "labor-cost-value" }
const _hoisted_26 = { class: "labor-cost-value" }
const _hoisted_27 = { class: "labor-tooltip-content" }
const _hoisted_28 = { class: "tooltip-row" }
const _hoisted_29 = { class: "tooltip-value" }
const _hoisted_30 = { class: "tooltip-row" }
const _hoisted_31 = { class: "tooltip-value" }
const _hoisted_32 = { class: "tooltip-formula" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "sidebar-actions" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "sidebar-excel-actions" }
const _hoisted_38 = { class: "excel-section-header" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "no-budget-container"
}
const _hoisted_42 = { class: "no-budget-text" }
const _hoisted_43 = {
  key: 1,
  class: "finance-table-wrapper"
}
const _hoisted_44 = { class: "finance-table" }
const _hoisted_45 = ["rowspan"]
const _hoisted_46 = ["rowspan"]
const _hoisted_47 = { class: "name-label" }
const _hoisted_48 = {
  key: 0,
  class: "budget-sum"
}
const _hoisted_49 = ["rowspan"]
const _hoisted_50 = { class: "name-label" }
const _hoisted_51 = {
  key: 0,
  class: "budget-sum"
}
const _hoisted_52 = ["rowspan"]
const _hoisted_53 = { class: "name-label" }
const _hoisted_54 = {
  key: 0,
  class: "budget-cell"
}
const _hoisted_55 = { class: "description-cell" }
const _hoisted_56 = ["onUpdate:modelValue", "onChange", "onFocus"]
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 1,
  class: "suga-calc-wrapper"
}
const _hoisted_59 = ["onUpdate:modelValue", "onChange", "onFocus"]
const _hoisted_60 = ["value"]
const _hoisted_61 = ["onUpdate:modelValue", "onInput", "onFocus"]
const _hoisted_62 = ["onUpdate:modelValue", "disabled"]
const _hoisted_63 = { class: "unit-price-cell" }
const _hoisted_64 = ["onUpdate:modelValue", "disabled", "onInput", "onFocus", "onBlur"]
const _hoisted_65 = { class: "count-cell" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled", "onInput", "onFocus", "onBlur"]
const _hoisted_67 = { class: "month-cell" }
const _hoisted_68 = ["onUpdate:modelValue", "disabled", "onInput", "onFocus", "onBlur"]
const _hoisted_69 = { class: "amount-cell" }
const _hoisted_70 = { class: "funding-cell" }
const _hoisted_71 = { class: "function-cell" }
const _hoisted_72 = {
  key: 0,
  class: "linked-buttons"
}
const _hoisted_73 = { class: "switch-label" }
const _hoisted_74 = {
  key: 1,
  class: "function-buttons"
}
const _hoisted_75 = {
  key: 2,
  class: "loading-container"
}
const _hoisted_76 = {
  key: 3,
  class: "no-data-container"
}
const _hoisted_77 = { class: "wizard-title-section" }
const _hoisted_78 = { class: "wizard-subtitle" }
const _hoisted_79 = { class: "progress-bar-container" }
const _hoisted_80 = {
  key: 0,
  class: "wizard-step"
}
const _hoisted_81 = { class: "step-icon-wrapper" }
const _hoisted_82 = {
  key: 1,
  class: "wizard-step"
}
const _hoisted_83 = { class: "step-icon-wrapper" }
const _hoisted_84 = {
  key: 2,
  class: "wizard-step"
}
const _hoisted_85 = { class: "step-icon-wrapper" }
const _hoisted_86 = ["value"]
const _hoisted_87 = {
  key: 3,
  class: "wizard-step"
}
const _hoisted_88 = { class: "step-icon-wrapper" }
const _hoisted_89 = { class: "delete-warning-text" }
const _hoisted_90 = {
  key: 0,
  class: "delete-notice mt-2"
}
const _hoisted_91 = { class: "snackbar-content" }

import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import PgmBudgetPayExcel from "./PgmBudgetPayExcel.vue";
import PgmBudgetHopeExcel from "./PgmBudgetHopeExcel.vue";

interface SugaData {
  suga_idx: number;
  suga_biz_gubun: string;
  suga_year: string;
  suga_rank: string;
  suga_money: number;
  suga_bonin: number;
  suga_wdate: string;
}

// 세금/보험 요율 인터페이스
interface TaxData {
  tr_idx?: number;
  tr_year?: string;
  tr_time_pay?: number;   // 최저시급
  tr_yeon?: number;       // 국민연금 요율
  tr_gun?: number;        // 건강보험 요율
  tr_go?: number;         // 고용보험 요율
  tr_jang?: number;       // 장기요양보험 요율
  tr_sil?: number;        // 실업급여 요율
  tr_san?: number;        // 산재보험 요율
  tr_labor_cost_rate?: number; // 인건비 지출 비율
}

// 소득세 테이블 인터페이스
interface SojiData {
  income1: number;
  income2: number;
  depe_1: number;
}

// Props
interface FinanceCode {
  fc_idx: number;
  fc_trcode: string;
  fc_trname: string;
  fc_year: string;
  fc_lcode: string;
  fc_lname: string;
  fc_mcode: string;
  fc_mname: string;
  fc_scode: string;
  fc_sname: string;
  fc_funding: string;
  fc_hope_scode?: string;
  fc_funding_name?: string;
  budget_amount?: string;
  description?: string;
  unit_price?: string;
  count?: string;
  months?: string;
  hb_idx?: number; // 예산 데이터 고유 ID
  hb_pay_rel?: string; // 급여-보험-퇴직금 연결 키 (고유 문자열)
  hb_pay_rel_manual?: 'Y' | 'N'; // 수동 편집 모드 여부 (Y: 자동계산 안됨)
  lcode_budget_sum?: number; // 관별 예산액 합계
  mcode_budget_sum?: number; // 항별 예산액 합계
  scode_budget_sum?: number; // 목별 예산액 합계
  isSalaryItem?: boolean; // 급여 항목 여부
  isLinkedItem?: boolean; // 급여에 연결된 사회보험/퇴직금 여부
  isRevenuePairItem?: boolean; // 본인부담금-장기요양급여 쌍 항목 여부
  hb_revenue_rel?: string; // 본인부담금-장기요양급여 연결 키 (고유 문자열)
  suga_rank?: string; // 선택된 수가 등급 (예: '180분')
  suga_times?: string; // 수가 횟수 (기본값: 20)
}

interface ProcessedFinanceCode extends FinanceCode {
  showTrcode: boolean;
  showLcode: boolean;
  showMcode: boolean;
  showScode: boolean;
  trcodeRowspan: number;
  lcodeRowspan: number;
  mcodeRowspan: number;
  scodeRowspan: number;
  isAddedRow?: boolean; // 추가된 행인지 여부
  hb_pay_rel?: string; // 급여-보험-퇴직금 연결 키 (고유 문자열)
  hb_pay_rel_manual?: 'Y' | 'N'; // 수동 편집 모드 여부 (Y: 자동계산 안됨)
  isLinkedItem?: boolean; // 급여에 연결된 사회보험/퇴직금 여부
  isSalaryItem?: boolean; // 급여 항목 여부
  isRevenuePairItem?: boolean; // 본인부담금-장기요양급여 쌍 항목 여부
  hb_revenue_rel?: string; // 본인부담금-장기요양급여 연결 키 (고유 문자열)
  suga_rank?: string; // 선택된 수가 등급 (예: '180분')
  suga_times?: string; // 수가 횟수 (기본값: 20)
  // 수동편집 모드에서 입력한 값 보존용
  manual_saved_unit_price?: string;
  manual_saved_count?: string;
  manual_saved_months?: string;
}

const totalSteps = 4;



// 저장 가능한 유효한 항목인지 확인 (내용, 단가, 명회, 개월이 모두 있어야 함)

export default /*@__PURE__*/_defineComponent({
  __name: 'PgmBudgetMain',
  props: {
    year: {},
    budgetClass: {},
    sugaList: {},
    sugaYear: {},
    sugaIsFallback: { type: Boolean },
    taxData: {},
    sojiData: {}
  },
  emits: ["open-starter", "year-change"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

// 수가 인터페이스 (props용)
const props = __props;

const searchParams = ref({
  lebYear: props.year || store.state.lebYear || new Date().getFullYear().toString(),
});

const selectedTrcode = ref<string>("ALL");
const saving = ref(false);
const loading = ref(false);
const initialLoading = ref(true); // 초기 페이지 로딩 상태
const deleting = ref(false);
const showDeleteDialog = ref(false);
const showSaveConfirmDialog = ref(false); // 저장 확인 다이얼로그
const financeCodes = ref<FinanceCode[]>([]);
const processedData = ref<ProcessedFinanceCode[]>([]);
const pendingDeleteIds = ref<number[]>([]); // 저장 시 삭제할 hb_idx 목록
const focusedPayRelGroup = ref<string | null>(null); // 포커스된 급여-보험-퇴직금 그룹 키

// 알림 스낵바 상태
const snackbar = ref({
  show: false,
  message: '',
  color: 'success',
  icon: 'mdi-check-circle',
  timeout: 3000
});

// 스낵바 표시 헬퍼 함수
const showSnackbar = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') => {
  const config = {
    success: { color: 'success', icon: 'mdi-check-circle' },
    error: { color: 'error', icon: 'mdi-alert-circle' },
    warning: { color: 'warning', icon: 'mdi-alert' },
    info: { color: 'info', icon: 'mdi-information' }
  };
  
  snackbar.value = {
    show: true,
    message,
    color: config[type].color,
    icon: config[type].icon,
    timeout: 3000
  };
};
// focusedRevenuePairGroup은 focusedRevenuePairItem으로 대체됨 (순서 기반 연동)
const sidebarPosition = ref<'left' | 'right'>('right'); // 사이드바 위치 (기본: 우측)

// 임직원보수일람표 다이얼로그 상태
const showPayExcelDialog = ref(false);
// 희망이음 예산업로드 다이얼로그 상태
const showHopeExcelDialog = ref(false);

// 급여-보험-퇴직금 연결 키 생성 (고유 키)
const generatePayRelKey = (): string => {
  return `pay_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};

// 사이드바 위치 토글
const toggleSidebarPosition = () => {
  sidebarPosition.value = sidebarPosition.value === 'left' ? 'right' : 'left';
};

// 급여 관련 scode (1111: 급여(직접비), 1112: 급여(간접비))
const SALARY_SCODES = ['1111', '1112'];
// 사회보험 관련 scode (1151: 사회보험(직접비), 1152: 사회보험(간접비))
const INSURANCE_SCODES = ['1151', '1152'];
// 퇴직금 관련 scode (1141: 퇴직금(직접비), 1142: 퇴직금(간접비))
const RETIREMENT_SCODES = ['1141', '1142'];
// 본인부담금-장기요양급여 쌍 scode (112: 본인부담금수입, 611: 장기요양급여수입)
const REVENUE_PAIR_SCODES = ['112', '611'];

// 표에서 숨길 scode 목록
const HIDDEN_SCODES_IN = ['113', '114', '115', '211', '913', '1013']; // 세입
const HIDDEN_SCODES_OUT = ['311', '312', '313', '314', '317', '318', '321', '331', '332']; // 세출

// 급여 종류 셀렉트 옵션 - 직접비(1111)용
const SALARY_OPTIONS_DIRECT = [
  { value: '사회복지사 급여', label: '사회복지사 급여', isCeo: false },
  { value: '사회복지사(대표자) 급여', label: '사회복지사(대표자) 급여', isCeo: true },
  { value: '요양보호사 급여', label: '요양보호사 급여', isCeo: false },
  { value: '요양보호사(대표자) 급여', label: '요양보호사(대표자) 급여', isCeo: true },
];

// 급여 종류 셀렉트 옵션 - 간접비(1112)용
const SALARY_OPTIONS_INDIRECT = [
  { value: '센터장 급여', label: '센터장 급여', isCeo: false },
  { value: '센터장(대표자) 급여', label: '센터장(대표자) 급여', isCeo: true },
];

// scode에 따른 급여 옵션 가져오기
const getSalaryOptions = (scode: string) => {
  if (scode === '1111') {
    // 직접비: 사회복지사, 요양보호사
    return SALARY_OPTIONS_DIRECT;
  } else if (scode === '1112') {
    // 간접비: 센터장
    return SALARY_OPTIONS_INDIRECT;
  }
  return [];
};

// 급여/퇴직금/사회보험 정렬 우선순위 (센터장 > 사회복지사 > 요양보호사)
const SALARY_SORT_ORDER: { [key: string]: number } = {
  '센터장': 1,
  '센터장(대표자)': 2,
  '사회복지사': 3,
  '사회복지사(대표자)': 4,
  '요양보호사': 5,
  '요양보호사(대표자)': 6,
};

// 급여/퇴직금/사회보험 항목의 정렬 순서 가져오기
const getSalaryTypeOrder = (description: string): number => {
  if (!description) return 999;
  
  // 급여 항목
  for (const key of Object.keys(SALARY_SORT_ORDER)) {
    if (description.startsWith(key + ' ')) {
      return SALARY_SORT_ORDER[key];
    }
  }
  return 999;
};

// 첫 예산 작성 데이터
const firstBudgetData = ref({
  caregiverCount: "",
  patientCount: "",
  selectedSugaTime: "",
  budgetMonths: "12"
});

// Emits
const emit = __emit;

// 예산 작성 마법사 관련
const showBudgetWizard = ref(false);
const currentStep = ref(1);
const isValidForSave = (item: ProcessedFinanceCode): boolean => {
  const description = item.description?.trim() || '';
  const unitPrice = item.unit_price?.replace(/,/g, '') || '0';
  const count = item.count?.replace(/,/g, '') || '0';
  const months = item.months?.replace(/,/g, '') || '0';
  
  // 내용이 없거나, 단가/명회/개월 중 하나라도 0이면 저장 대상 아님
  if (!description) return false;
  if (Number(unitPrice) === 0 && Number(count) === 0 && Number(months) === 0) return false;
  
  return true;
};

const saveAllData = async () => {
  if (!store.state.user?.m_sisul_code) {
    console.error("시설 코드가 없습니다.");
    return;
  }

  saving.value = true;
  try {
    // 1. 삭제 대기 중인 항목들 먼저 삭제
    if (pendingDeleteIds.value.length > 0) {
      await axios.post("/api/budget/delete-multiple", {
        hbIdxList: pendingDeleteIds.value,
      });
      // 삭제 완료 후 목록 초기화
      pendingDeleteIds.value = [];
    }

    // 2. 유효한 항목만 필터링 (기존 데이터 또는 새로 입력된 유효한 데이터)
    const validItems = processedData.value.filter((item) => {
      // 기존 데이터(hb_idx가 있는 경우)는 항상 저장 (업데이트)
      if (item.hb_idx) return true;
      // 새 데이터는 유효성 검사 통과해야 저장
      return isValidForSave(item);
    });
    
    // 모든 항목 저장 (hb_idx 유무에 따라 INSERT/UPDATE 구분)
    const budgetList = validItems.map((item) => {
      // 콤마 제거하여 숫자로 변환
      const unitPrice = item.unit_price?.replace(/,/g, "") || "0";
      const count = item.count?.replace(/,/g, "") || "0";
      const months = item.months?.replace(/,/g, "") || "0";
      
      // 정확한 금액 계산 (연결된 항목은 보정된 금액 사용)
      const amount = getExactAmount(item).toString();

      // 대표자 여부 확인 (급여 항목에서 description에 "(대표자)" 포함 여부)
      const isCeo = item.isSalaryItem && item.description?.includes('(대표자)') ? 'Y' : 'N';

      return {
        hb_idx: item.hb_idx || null, // 없으면 null (INSERT)
        trcode: item.fc_trcode, // INSERT 시 필요
        scode: item.fc_scode, // INSERT 시 필요
        hb_pay_rel: item.hb_pay_rel || null,
        hb_pay_rel_manual: item.hb_pay_rel_manual || 'N',
        hb_is_ceo: isCeo,
        hb_revenue_rel: item.hb_revenue_rel || null,
        description: item.description || "",
        unit_price: unitPrice,
        count: count,
        months: months,
        amount: amount,
        fc_funding: item.fc_funding || "",
      };
    });

    // 3. 백엔드로 저장 요청
    const response = await axios.post("/api/budget/save", {
      sisulCode: store.state.user.m_sisul_code,
      year: searchParams.value.lebYear,
      budClass: props.budgetClass || '',
      budgetList: budgetList,
    });

    if (response.data.success) {
      // 저장 후 전체 표 다시 조회 (화면 유지, 데이터만 갱신)
      await fetchFinanceCodes(true);
      showSnackbar('예산이 성공적으로 저장되었습니다.', 'success');
    } else {
      console.error("저장 실패:", response.data.message);
      showSnackbar('저장에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'), 'error');
    }
  } catch (error) {
    console.error("저장 오류:", error);
    showSnackbar('저장 중 오류가 발생했습니다.', 'error');
  } finally {
    saving.value = false;
  }
};

// 저장 확인 후 실제 저장 수행
const confirmSave = async () => {
  showSaveConfirmDialog.value = false;
  await saveAllData();
};

// 예산 데이터 백엔드에서 불러오기
const loadBudgetData = async () => {
  if (!store.state.user?.m_sisul_code) {
    return;
  }

  try {
    const response = await axios.get("/api/budget", {
      params: {
        sisulCode: store.state.user.m_sisul_code,
        year: searchParams.value.lebYear,
        gubun: selectedTrcode.value === "ALL" ? null : selectedTrcode.value,
        budClass: props.budgetClass || '', // 추경차수 조건 추가 (빈 문자열 = 본예산)
      },
    });

    if (response.data.success && response.data.data) {
      const budgetData = response.data.data;

      // 예산 데이터를 financeCodes에 매핑
      // 같은 scode에 여러 행이 있을 수 있으므로 먼저 그룹화
      const budgetByScodeMap = new Map<string, any[]>();
      budgetData.forEach((bd: any) => {
        const key = `${bd.hb_gubun}-${bd.hb_scode}`;
        if (!budgetByScodeMap.has(key)) {
          budgetByScodeMap.set(key, []);
        }
        budgetByScodeMap.get(key)?.push(bd);
      });

      // 새로운 financeCodes 배열 생성 (여러 행 지원)
      const newFinanceCodes: FinanceCode[] = [];
      
      financeCodes.value.forEach((fc) => {
        const key = `${fc.fc_trcode}-${fc.fc_scode}`;
        const matchingBudgets = budgetByScodeMap.get(key);

        if (matchingBudgets && matchingBudgets.length > 0) {
          // 각 예산 데이터에 대해 행 생성
          matchingBudgets.forEach((budget) => {
            const isSalary = SALARY_SCODES.includes(fc.fc_scode);
            const isInsurance = INSURANCE_SCODES.includes(fc.fc_scode);
            const isRetirement = RETIREMENT_SCODES.includes(fc.fc_scode);
            const isLinked = (isInsurance || isRetirement) && budget.hb_pay_rel;
            // 수입 쌍(112/611)은 세입(IN)에서만 유효
            const isRevenuePair = fc.fc_trcode === 'IN' && REVENUE_PAIR_SCODES.includes(fc.fc_scode);
            
            // 본인부담금/장기요양급여의 경우 description에서 수가 정보 파싱
            let sugaRank = '';
            let sugaTimes = '20'; // 기본값
            if (isRevenuePair && budget.hb_memo) {
              // "180분 X 20" 또는 "180분수가 X 20" 형태 파싱
              const match = budget.hb_memo.match(/^(.+?)\s*[Xx×]\s*(\d+)$/);
              if (match) {
                sugaRank = match[1].replace('수가', '').trim();
                sugaTimes = match[2];
              }
            }
            
            newFinanceCodes.push({
              ...fc,
              hb_idx: budget.hb_idx,
              hb_pay_rel: budget.hb_pay_rel || null,
              hb_pay_rel_manual: budget.hb_pay_rel_manual || 'N',
              hb_revenue_rel: budget.hb_revenue_rel || null,
              description: budget.hb_memo || "",
              unit_price: budget.hb_price ? Number(budget.hb_price).toLocaleString() : "",
              count: budget.hb_person ? Number(budget.hb_person).toLocaleString() : "",
              months: budget.hb_month ? Number(budget.hb_month).toLocaleString() : "",
              isSalaryItem: isSalary,
              isLinkedItem: isLinked,
              isRevenuePairItem: isRevenuePair,  // fc_scode 기반 (112/611)
              suga_rank: isRevenuePair ? sugaRank : undefined,
              suga_times: isRevenuePair ? sugaTimes : undefined,
            });
          });
        } else {
          // 예산 데이터가 없으면 기본 행만 추가
          // 수입 쌍(112/611)은 세입(IN)에서만 유효
          const isRevenuePair = fc.fc_trcode === 'IN' && REVENUE_PAIR_SCODES.includes(fc.fc_scode);
          newFinanceCodes.push({ 
            ...fc,
            isRevenuePairItem: isRevenuePair,  // fc_scode 기반 (112/611, 세입만)
            suga_rank: isRevenuePair ? '180분' : undefined,
            suga_times: isRevenuePair ? '20' : undefined,
          });
        }
      });

      financeCodes.value = newFinanceCodes;
      // 저장 후 로드 시 이전 편집 상태가 남지 않도록 초기화
      processedData.value = [];
      processFinanceCodes();
    } else {
      processFinanceCodes();
    }
  } catch (error) {
    console.error("예산 데이터 조회 오류:", error);
    processFinanceCodes();
  }
};

// props.sugaList가 변경되면 기본값 설정
watch(() => props.sugaList, (newList) => {
  if (newList && newList.length > 0) {
    // '180' 항목을 기본값으로 설정
    const defaultSuga = newList.find(suga => suga.suga_rank === '180분');
    if (defaultSuga && !firstBudgetData.value.selectedSugaTime) {
      firstBudgetData.value.selectedSugaTime = defaultSuga.suga_rank;
    }
  }
}, { immediate: true });

// 재무코드 조회 (silent: true면 로딩 표시 없이 데이터만 갱신)
const fetchFinanceCodes = async (silent: boolean = false) => {
  if (!silent) {
    loading.value = true;
    // 새로운 데이터를 가져올 때 processedData 초기화 (silent가 아닐 때만)
    processedData.value = [];
  }
  
  try {
    if (selectedTrcode.value === "ALL") {
      // 전체 조회: 세입과 세출을 모두 가져와서 합치기
      const [inResponse, outResponse] = await Promise.all([
        axios.get("/api/finance/codes", {
          params: {
            year: searchParams.value.lebYear,
            trcode: "IN",
            sisulCode: store.state.user?.m_sisul_code,
          },
        }),
        axios.get("/api/finance/codes", {
          params: {
            year: searchParams.value.lebYear,
            trcode: "OUT",
            sisulCode: store.state.user?.m_sisul_code,
          },
        }),
      ]);

      const inData = inResponse.data.success ? inResponse.data.data : [];
      const outData = outResponse.data.success ? outResponse.data.data : [];
      financeCodes.value = [...inData, ...outData];
      // 재무코드 조회 후 예산 데이터도 불러오기
      await loadBudgetData();
    } else {
      const response = await axios.get("/api/finance/codes", {
        params: {
          year: searchParams.value.lebYear,
          trcode: selectedTrcode.value,
          sisulCode: store.state.user?.m_sisul_code,
        },
      });

      if (response.data.success) {
        financeCodes.value = response.data.data;
        // 재무코드 조회 후 예산 데이터도 불러오기
        await loadBudgetData();
      } else {
        financeCodes.value = [];
        processedData.value = [];
      }
    }
  } catch (error) {
    console.error("재무코드 조회 오류:", error);
    financeCodes.value = [];
    processedData.value = [];
  } finally {
    if (!silent) {
      loading.value = false;
    }
    // 초기 로딩 완료 (약간의 딜레이로 부드러운 전환)
    if (initialLoading.value) {
      setTimeout(() => {
        initialLoading.value = false;
      }, 100);
    }
  }
};

// rowspan 계산을 위한 데이터 가공
const processFinanceCodes = () => {
  const data: ProcessedFinanceCode[] = [];
  
  // financeCodes를 기준으로 처리하되, 기존 processedData에서 편집된 데이터와 추가된 행을 병합
  const existingDataMap = new Map<number, ProcessedFinanceCode>();
  const addedRows: ProcessedFinanceCode[] = [];
  
  // 기존 processedData에서 편집된 데이터와 추가된 행 분리
  processedData.value.forEach(item => {
    if (item.isAddedRow) {
      addedRows.push(item);
    } else if (item.fc_idx) {
      existingDataMap.set(item.fc_idx, item);
    }
  });
  
  // financeCodes를 기준으로 sourceData 생성
  const sourceData: any[] = financeCodes.value.map(item => {
    const existing = existingDataMap.get(item.fc_idx);
    if (existing) {
      // 기존 편집 데이터가 있으면 그것을 사용
      return {
        ...item,
        hb_idx: existing.hb_idx || item.hb_idx,
        budget_amount: existing.budget_amount !== undefined ? existing.budget_amount : (item.budget_amount || ""),
        description: existing.description !== undefined ? existing.description : (item.description || ""),
        unit_price: existing.unit_price !== undefined ? existing.unit_price : (item.unit_price || ""),
        count: existing.count !== undefined ? existing.count : (item.count || ""),
        months: existing.months !== undefined ? existing.months : (item.months || ""),
        lcode_budget_sum: item.lcode_budget_sum || 0,
        mcode_budget_sum: item.mcode_budget_sum || 0,
        scode_budget_sum: item.scode_budget_sum || 0,
        isAddedRow: false
      };
    } else {
      return {
        ...item,
        hb_idx: item.hb_idx,
        budget_amount: item.budget_amount || "",
        description: item.description || "",
        unit_price: item.unit_price || "",
        count: item.count || "",
        months: item.months || "",
        lcode_budget_sum: item.lcode_budget_sum || 0,
        mcode_budget_sum: item.mcode_budget_sum || 0,
        scode_budget_sum: item.scode_budget_sum || 0,
        isAddedRow: false
      };
    }
  });
  
  // 추가된 행(isAddedRow: true)은 유지
  sourceData.push(...addedRows);
  
  // 숨길 scode 필터링
  const filteredSourceData = sourceData.filter(item => {
    if (item.fc_trcode === 'IN' && HIDDEN_SCODES_IN.includes(item.fc_scode)) {
      return false;
    }
    if (item.fc_trcode === 'OUT' && HIDDEN_SCODES_OUT.includes(item.fc_scode)) {
      return false;
    }
    return true;
  });

  // 급여/퇴직금/사회보험 항목 정렬 (센터장 > 사회복지사 > 요양보호사 순서)
  // 같은 scode 그룹 내에서만 정렬
  const sortedSourceData = [...filteredSourceData].sort((a, b) => {
    // 먼저 trcode, lcode, mcode, scode 순서대로 비교
    if (a.fc_trcode !== b.fc_trcode) return a.fc_trcode.localeCompare(b.fc_trcode);
    if (a.fc_lcode !== b.fc_lcode) return a.fc_lcode.localeCompare(b.fc_lcode);
    if (a.fc_mcode !== b.fc_mcode) return a.fc_mcode.localeCompare(b.fc_mcode);
    if (a.fc_scode !== b.fc_scode) return a.fc_scode.localeCompare(b.fc_scode);
    
    // 같은 scode 내에서 급여/퇴직금/사회보험 관련 항목인지 확인
    const isSalaryRelatedA = SALARY_SCODES.includes(a.fc_scode) || 
                            INSURANCE_SCODES.includes(a.fc_scode) || 
                            RETIREMENT_SCODES.includes(a.fc_scode);
    const isSalaryRelatedB = SALARY_SCODES.includes(b.fc_scode) || 
                            INSURANCE_SCODES.includes(b.fc_scode) || 
                            RETIREMENT_SCODES.includes(b.fc_scode);
    
    // 급여 관련 항목이면 description 기준 정렬
    if (isSalaryRelatedA && isSalaryRelatedB) {
      const orderA = getSalaryTypeOrder(a.description || '');
      const orderB = getSalaryTypeOrder(b.description || '');
      return orderA - orderB;
    }
    
    return 0;
  });

  // rowspan 카운트
  const trcodeGroups: { [key: string]: number } = {};
  const lcodeGroups: { [key: string]: number } = {};
  const mcodeGroups: { [key: string]: number } = {};
  const scodeGroups: { [key: string]: number } = {};

  sortedSourceData.forEach((item) => {
    const trcodeKey = `${item.fc_trcode}`;
    const lcodeKey = `${item.fc_trcode}-${item.fc_lcode}`;
    const mcodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}`;
    const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;

    trcodeGroups[trcodeKey] = (trcodeGroups[trcodeKey] || 0) + 1;
    lcodeGroups[lcodeKey] = (lcodeGroups[lcodeKey] || 0) + 1;
    mcodeGroups[mcodeKey] = (mcodeGroups[mcodeKey] || 0) + 1;
    scodeGroups[scodeKey] = (scodeGroups[scodeKey] || 0) + 1;
  });

  // 2차: 표시 여부 결정
  let prevTrcode = "";
  let prevLcode = "";
  let prevMcode = "";
  let prevScode = "";
  let trcodeCount = 0;
  let lcodeCount = 0;
  let mcodeCount = 0;
  let scodeCount = 0;

  sortedSourceData.forEach((item) => {
    const trcodeKey = `${item.fc_trcode}`;
    const lcodeKey = `${item.fc_trcode}-${item.fc_lcode}`;
    const mcodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}`;
    const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;

    const showTrcode = item.fc_trcode !== prevTrcode;
    const showLcode = lcodeKey !== `${prevTrcode}-${prevLcode}`;
    const showMcode = mcodeKey !== `${prevTrcode}-${prevLcode}-${prevMcode}`;
    const showScode = scodeKey !== `${prevTrcode}-${prevLcode}-${prevMcode}-${prevScode}`;

    if (showTrcode) {
      prevTrcode = item.fc_trcode;
      trcodeCount = 0;
    }

    if (showLcode) {
      prevLcode = item.fc_lcode;
      lcodeCount = 0;
    }

    if (showMcode) {
      prevMcode = item.fc_mcode;
      mcodeCount = 0;
    }

    if (showScode) {
      prevScode = item.fc_scode;
      scodeCount = 0;
    }

    data.push({
      ...item,
      showTrcode: trcodeCount === 0,
      showLcode: lcodeCount === 0,
      showMcode: mcodeCount === 0,
      showScode: scodeCount === 0,
      trcodeRowspan: trcodeGroups[trcodeKey],
      lcodeRowspan: lcodeGroups[lcodeKey],
      mcodeRowspan: mcodeGroups[mcodeKey],
      scodeRowspan: scodeGroups[scodeKey],
    });

    trcodeCount++;
    lcodeCount++;
    mcodeCount++;
    scodeCount++;
  });

  processedData.value = data;
};

// 숫자 포맷팅
const formatNumber = (event: any, item: any, field: string) => {
  const value = event.target.value.replace(/[^0-9]/g, "");
  item[field] = value ? Number(value).toLocaleString() : "";
};

// 금액 계산 (단가 × 명(회) × 개월)
// 연결된 항목(퇴직금, 사회보험)의 경우 정확한 총액으로 보정
const calculateAmount = (item: ProcessedFinanceCode) => {
  const unitPrice = Number(item.unit_price?.replace(/,/g, "") || 0);
  const count = Number(item.count?.replace(/,/g, "") || 0);
  const months = Number(item.months?.replace(/,/g, "") || 0);
  
  // 연결된 항목(퇴직금, 사회보험)인 경우 정확한 총액 계산
  if (item.isLinkedItem && item.hb_pay_rel && item.hb_pay_rel_manual !== 'Y') {
    // 연결된 급여 항목 찾기
    const salaryItem = processedData.value.find(
      row => row.hb_pay_rel === item.hb_pay_rel && row.isSalaryItem
    );
    
    if (salaryItem) {
      const salaryUnitPrice = Number(salaryItem.unit_price?.replace(/,/g, "") || 0);
      const salaryCount = Number(salaryItem.count?.replace(/,/g, "") || 0);
      const salaryMonths = Number(salaryItem.months?.replace(/,/g, "") || 0);
      const isCeo = (salaryItem.description || '').includes('(대표자)');
      
      // 퇴직금인 경우: 정확한 총액 = 월 총 급여 × 개월 / 12
      if (RETIREMENT_SCODES.includes(item.fc_scode)) {
        const exactTotal = isCeo ? 0 : Math.round((salaryUnitPrice * salaryCount * salaryMonths) / 12);
        return exactTotal > 0 ? exactTotal.toLocaleString() : "-";
      }
      
      // 사회보험인 경우: 정확한 총액 = 월 총 급여 × 요율들의 합 × 개월
      if (INSURANCE_SCODES.includes(item.fc_scode) && props.taxData) {
        const totalMonthlySalary = salaryUnitPrice * salaryCount;
        
        const nationalPension = Math.round(totalMonthlySalary * (props.taxData.tr_yeon || 0));
        const healthInsurance = Math.round(totalMonthlySalary * (props.taxData.tr_gun || 0));
        const longTermCare = Math.round(healthInsurance * (props.taxData.tr_jang || 0));
        const employmentInsurance = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_go || 0));
        const unemployment = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_sil || 0));
        const industrialAccident = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_san || 0));
        
        const monthlyInsurance = nationalPension + healthInsurance + longTermCare + 
                                 employmentInsurance + unemployment + industrialAccident;
        const exactTotal = monthlyInsurance * salaryMonths;
        return exactTotal > 0 ? exactTotal.toLocaleString() : "-";
      }
    }
  }
  
  // 일반 항목: 단순 계산
  const amount = unitPrice * count * months;
  return amount > 0 ? amount.toLocaleString() : "-";
};

// 정확한 금액 계산 (숫자 반환) - 연결된 항목의 경우 보정된 금액 반환
const getExactAmount = (item: ProcessedFinanceCode): number => {
  const unitPrice = Number(item.unit_price?.replace(/,/g, "") || 0);
  const count = Number(item.count?.replace(/,/g, "") || 0);
  const months = Number(item.months?.replace(/,/g, "") || 0);
  
  // 연결된 항목(퇴직금, 사회보험)인 경우 정확한 총액 계산
  if (item.isLinkedItem && item.hb_pay_rel && item.hb_pay_rel_manual !== 'Y') {
    // 연결된 급여 항목 찾기
    const salaryItem = processedData.value.find(
      row => row.hb_pay_rel === item.hb_pay_rel && row.isSalaryItem
    );
    
    if (salaryItem) {
      const salaryUnitPrice = Number(salaryItem.unit_price?.replace(/,/g, "") || 0);
      const salaryCount = Number(salaryItem.count?.replace(/,/g, "") || 0);
      const salaryMonths = Number(salaryItem.months?.replace(/,/g, "") || 0);
      const isCeo = (salaryItem.description || '').includes('(대표자)');
      
      // 퇴직금인 경우: 정확한 총액 = 월 총 급여 × 개월 / 12
      if (RETIREMENT_SCODES.includes(item.fc_scode)) {
        return isCeo ? 0 : Math.round((salaryUnitPrice * salaryCount * salaryMonths) / 12);
      }
      
      // 사회보험인 경우: 정확한 총액 = 월 총 급여 × 요율들의 합 × 개월
      if (INSURANCE_SCODES.includes(item.fc_scode) && props.taxData) {
        const totalMonthlySalary = salaryUnitPrice * salaryCount;
        
        const nationalPension = Math.round(totalMonthlySalary * (props.taxData.tr_yeon || 0));
        const healthInsurance = Math.round(totalMonthlySalary * (props.taxData.tr_gun || 0));
        const longTermCare = Math.round(healthInsurance * (props.taxData.tr_jang || 0));
        const employmentInsurance = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_go || 0));
        const unemployment = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_sil || 0));
        const industrialAccident = isCeo ? 0 : Math.round(totalMonthlySalary * (props.taxData.tr_san || 0));
        
        const monthlyInsurance = nationalPension + healthInsurance + longTermCare + 
                                 employmentInsurance + unemployment + industrialAccident;
        return monthlyInsurance * salaryMonths;
      }
    }
  }
  
  // 일반 항목: 단순 계산
  return unitPrice * count * months;
};

// 관(L코드)별 예산액 합계 계산 (실시간)
const getLcodeBudgetSum = (item: ProcessedFinanceCode) => {
  const lcodeKey = `${item.fc_trcode}-${item.fc_lcode}`;
  const sameRows = processedData.value.filter(
    (row) => `${row.fc_trcode}-${row.fc_lcode}` === lcodeKey
  );
  
  const total = sameRows.reduce((sum, row) => {
    return sum + getExactAmount(row);
  }, 0);
  
  return total;
};

// 항(M코드)별 예산액 합계 계산 (실시간)
const getMcodeBudgetSum = (item: ProcessedFinanceCode) => {
  const mcodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}`;
  const sameRows = processedData.value.filter(
    (row) => `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}` === mcodeKey
  );
  
  const total = sameRows.reduce((sum, row) => {
    return sum + getExactAmount(row);
  }, 0);
  
  return total;
};

// 목(S코드)별 예산액 합계 계산 (실시간)
const getScodeBudgetSum = (item: ProcessedFinanceCode) => {
  const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;
  const sameRows = processedData.value.filter(
    (row) => `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}-${row.fc_scode}` === scodeKey
  );
  
  const total = sameRows.reduce((sum, row) => {
    return sum + getExactAmount(row);
  }, 0);
  
  return total;
};

// rowspan만 재계산하는 함수
const recalculateRowspans = () => {
  const data = processedData.value;
  
  // rowspan 카운트
  const trcodeGroups: { [key: string]: number } = {};
  const lcodeGroups: { [key: string]: number } = {};
  const mcodeGroups: { [key: string]: number } = {};
  const scodeGroups: { [key: string]: number } = {};

  data.forEach((item) => {
    const trcodeKey = `${item.fc_trcode}`;
    const lcodeKey = `${item.fc_trcode}-${item.fc_lcode}`;
    const mcodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}`;
    const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;

    trcodeGroups[trcodeKey] = (trcodeGroups[trcodeKey] || 0) + 1;
    lcodeGroups[lcodeKey] = (lcodeGroups[lcodeKey] || 0) + 1;
    mcodeGroups[mcodeKey] = (mcodeGroups[mcodeKey] || 0) + 1;
    scodeGroups[scodeKey] = (scodeGroups[scodeKey] || 0) + 1;
  });

  // 표시 여부 및 rowspan 업데이트
  let prevTrcode = "";
  let prevLcode = "";
  let prevMcode = "";
  let prevScode = "";
  let trcodeCount = 0;
  let lcodeCount = 0;
  let mcodeCount = 0;
  let scodeCount = 0;

  data.forEach((item) => {
    const trcodeKey = `${item.fc_trcode}`;
    const lcodeKey = `${item.fc_trcode}-${item.fc_lcode}`;
    const mcodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}`;
    const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;

    const showTrcode = item.fc_trcode !== prevTrcode;
    const showLcode = lcodeKey !== `${prevTrcode}-${prevLcode}`;
    const showMcode = mcodeKey !== `${prevTrcode}-${prevLcode}-${prevMcode}`;
    const showScode = scodeKey !== `${prevTrcode}-${prevLcode}-${prevMcode}-${prevScode}`;

    if (showTrcode) {
      prevTrcode = item.fc_trcode;
      trcodeCount = 0;
    }

    if (showLcode) {
      prevLcode = item.fc_lcode;
      lcodeCount = 0;
    }

    if (showMcode) {
      prevMcode = item.fc_mcode;
      mcodeCount = 0;
    }

    if (showScode) {
      prevScode = item.fc_scode;
      scodeCount = 0;
    }

    item.showTrcode = trcodeCount === 0;
    item.showLcode = lcodeCount === 0;
    item.showMcode = mcodeCount === 0;
    item.showScode = scodeCount === 0;
    item.trcodeRowspan = trcodeGroups[trcodeKey];
    item.lcodeRowspan = lcodeGroups[lcodeKey];
    item.mcodeRowspan = mcodeGroups[mcodeKey];
    item.scodeRowspan = scodeGroups[scodeKey];

    trcodeCount++;
    lcodeCount++;
    mcodeCount++;
    scodeCount++;
  });
};

// 급여 scode에 매칭되는 사회보험/퇴직금 scode 가져오기
const getLinkedScodes = (salaryScode: string): { insurance: string; retirement: string } | null => {
  if (salaryScode === '1111') {
    return { insurance: '1151', retirement: '1141' }; // 직접비
  } else if (salaryScode === '1112') {
    return { insurance: '1152', retirement: '1142' }; // 간접비
  }
  return null;
};

// 본인부담금(112) ↔ 장기요양급여수입(611) 짝 scode 가져오기
const getRevenuePairScode = (scode: string): string | null => {
  if (scode === '112') return '611';
  if (scode === '611') return '112';
  return null;
};

// 수입 쌍 연결 키 생성 (고유 키)
const generateRevenueRelKey = (): string => {
  return `rev_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};

// scode로 해당하는 financeCode 찾기
const findFinanceCodeByScode = (trcode: string, scode: string): FinanceCode | undefined => {
  return financeCodes.value.find(fc => fc.fc_trcode === trcode && fc.fc_scode === scode);
};

// scode 그룹의 마지막 인덱스 찾기 헬퍼 함수
const findLastIndexOfScodeGroup = (scodeKey: string, startIndex: number = 0): number => {
  let lastIndex = -1;
  for (let i = startIndex; i < processedData.value.length; i++) {
    const row = processedData.value[i];
    const rowScodeKey = `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}-${row.fc_scode}`;
    if (rowScodeKey === scodeKey) {
      lastIndex = i;
    }
  }
  return lastIndex;
};

// 행 추가 (화면에만 추가, 저장 시 DB INSERT)
// 급여 scode인 경우 사회보험/퇴직금도 함께 생성하고 같은 pay_rel 키로 연결
const addRow = (index: number) => {
  const currentItem = processedData.value[index];
  const isSalaryScode = SALARY_SCODES.includes(currentItem.fc_scode);
  
  if (isSalaryScode) {
    // 급여 scode인 경우: 급여 + 사회보험 + 퇴직금을 함께 생성
    const payRelKey = generatePayRelKey();
    const linkedScodes = getLinkedScodes(currentItem.fc_scode);
    
    if (!linkedScodes) {
      console.error("연결 scode를 찾을 수 없습니다.");
      return;
    }
    
    // 연결된 financeCode 찾기
    const insuranceFinanceCode = findFinanceCodeByScode('OUT', linkedScodes.insurance);
    const retirementFinanceCode = findFinanceCodeByScode('OUT', linkedScodes.retirement);
    
    // 급여 행 생성 (hb_idx 없음 - 저장 시 INSERT)
    const salaryRow: ProcessedFinanceCode = {
      ...currentItem,
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: payRelKey,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: undefined,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: true,
      isLinkedItem: false,
      isRevenuePairItem: false,
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    // 사회보험 행 생성
    const insuranceRow: ProcessedFinanceCode = {
      fc_idx: insuranceFinanceCode?.fc_idx || 0,
      fc_trcode: 'OUT',
      fc_trname: '세출',
      fc_year: currentItem.fc_year,
      fc_lcode: insuranceFinanceCode?.fc_lcode || '',
      fc_lname: insuranceFinanceCode?.fc_lname || '',
      fc_mcode: insuranceFinanceCode?.fc_mcode || '',
      fc_mname: insuranceFinanceCode?.fc_mname || '',
      fc_scode: linkedScodes.insurance,
      fc_sname: insuranceFinanceCode?.fc_sname || '사회보험부담금',
      fc_funding: insuranceFinanceCode?.fc_funding || '',
      fc_funding_name: insuranceFinanceCode?.fc_funding_name || '',
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: payRelKey,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: undefined,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: false,
      isLinkedItem: true,
      isRevenuePairItem: false,
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    // 퇴직금 행 생성
    const retirementRow: ProcessedFinanceCode = {
      fc_idx: retirementFinanceCode?.fc_idx || 0,
      fc_trcode: 'OUT',
      fc_trname: '세출',
      fc_year: currentItem.fc_year,
      fc_lcode: retirementFinanceCode?.fc_lcode || '',
      fc_lname: retirementFinanceCode?.fc_lname || '',
      fc_mcode: retirementFinanceCode?.fc_mcode || '',
      fc_mname: retirementFinanceCode?.fc_mname || '',
      fc_scode: linkedScodes.retirement,
      fc_sname: retirementFinanceCode?.fc_sname || '퇴직금',
      fc_funding: retirementFinanceCode?.fc_funding || '',
      fc_funding_name: retirementFinanceCode?.fc_funding_name || '',
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: payRelKey,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: undefined,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: false,
      isLinkedItem: true,
      isRevenuePairItem: false,
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    // 급여 행 추가
    const salaryScodeKey = `${salaryRow.fc_trcode}-${salaryRow.fc_lcode}-${salaryRow.fc_mcode}-${salaryRow.fc_scode}`;
    const salaryInsertIndex = findLastIndexOfScodeGroup(salaryScodeKey, index);
    processedData.value.splice((salaryInsertIndex >= 0 ? salaryInsertIndex : index) + 1, 0, salaryRow);
    
    // 사회보험 행 추가
    const insuranceScodeKey = `${insuranceRow.fc_trcode}-${insuranceRow.fc_lcode}-${insuranceRow.fc_mcode}-${insuranceRow.fc_scode}`;
    const insuranceInsertIndex = findLastIndexOfScodeGroup(insuranceScodeKey);
    if (insuranceInsertIndex >= 0) {
      processedData.value.splice(insuranceInsertIndex + 1, 0, insuranceRow);
    }
    
    // 퇴직금 행 추가
    const retirementScodeKey = `${retirementRow.fc_trcode}-${retirementRow.fc_lcode}-${retirementRow.fc_mcode}-${retirementRow.fc_scode}`;
    const retirementInsertIndex = findLastIndexOfScodeGroup(retirementScodeKey);
    if (retirementInsertIndex >= 0) {
      processedData.value.splice(retirementInsertIndex + 1, 0, retirementRow);
    }
    
    recalculateRowspans();
    
  } else if (currentItem.fc_trcode === 'IN' && REVENUE_PAIR_SCODES.includes(currentItem.fc_scode)) {
    // 본인부담금(112) 또는 장기요양급여수입(611) 추가 시 짝도 함께 생성 (세입만)
    const revenueRelKey = generateRevenueRelKey();
    const pairScode = getRevenuePairScode(currentItem.fc_scode);
    
    if (!pairScode) {
      console.error("짝 scode를 찾을 수 없습니다.");
      return;
    }
    
    const pairFinanceCode = findFinanceCodeByScode('IN', pairScode);
    
    // 현재 항목 행 생성
    const currentRow: ProcessedFinanceCode = {
      ...currentItem,
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: undefined,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: revenueRelKey,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: false,
      isLinkedItem: false,
      isRevenuePairItem: true,
      suga_rank: '180분',
      suga_times: '20',
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    // 짝 항목 행 생성
    const pairRow: ProcessedFinanceCode = {
      fc_idx: pairFinanceCode?.fc_idx || 0,
      fc_trcode: 'IN',
      fc_trname: '세입',
      fc_year: currentItem.fc_year,
      fc_lcode: pairFinanceCode?.fc_lcode || '',
      fc_lname: pairFinanceCode?.fc_lname || '',
      fc_mcode: pairFinanceCode?.fc_mcode || '',
      fc_mname: pairFinanceCode?.fc_mname || '',
      fc_scode: pairScode,
      fc_sname: pairFinanceCode?.fc_sname || (pairScode === '112' ? '본인부담금수입' : '장기요양급여수입'),
      fc_funding: pairFinanceCode?.fc_funding || '',
      fc_funding_name: pairFinanceCode?.fc_funding_name || '',
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: undefined,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: revenueRelKey,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: false,
      isLinkedItem: false,
      isRevenuePairItem: true,
      suga_rank: '180분',
      suga_times: '20',
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    // 현재 항목 행 추가
    const currentScodeKey = `${currentRow.fc_trcode}-${currentRow.fc_lcode}-${currentRow.fc_mcode}-${currentRow.fc_scode}`;
    const currentInsertIndex = findLastIndexOfScodeGroup(currentScodeKey, index);
    processedData.value.splice((currentInsertIndex >= 0 ? currentInsertIndex : index) + 1, 0, currentRow);
    
    // 짝 항목 행 추가
    const pairScodeKey = `${pairRow.fc_trcode}-${pairRow.fc_lcode}-${pairRow.fc_mcode}-${pairRow.fc_scode}`;
    const pairInsertIndex = findLastIndexOfScodeGroup(pairScodeKey);
    if (pairInsertIndex >= 0) {
      processedData.value.splice(pairInsertIndex + 1, 0, pairRow);
    }
    
    recalculateRowspans();
    
  } else {
    // 일반 행 추가
    const scodeKey = `${currentItem.fc_trcode}-${currentItem.fc_lcode}-${currentItem.fc_mcode}-${currentItem.fc_scode}`;
    const insertIndex = findLastIndexOfScodeGroup(scodeKey, index);
    
    const newRow: ProcessedFinanceCode = {
      ...currentItem,
      hb_idx: undefined, // 저장 시 INSERT
      hb_pay_rel: undefined,
      hb_pay_rel_manual: 'N',
      hb_revenue_rel: undefined,
      budget_amount: "",
      description: "",
      unit_price: "",
      count: "",
      months: "",
      isAddedRow: true,
      isSalaryItem: false,
      isLinkedItem: false,
      isRevenuePairItem: false,
      showTrcode: false,
      showLcode: false,
      showMcode: false,
      showScode: false,
      trcodeRowspan: 0,
      lcodeRowspan: 0,
      mcodeRowspan: 0,
      scodeRowspan: 0,
    };
    
    processedData.value.splice((insertIndex >= 0 ? insertIndex : index) + 1, 0, newRow);
    recalculateRowspans();
  }
};

// 같은 목 코드를 가진 행의 개수 확인
const getSameScodeRowCount = (item: ProcessedFinanceCode) => {
  const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;
  return processedData.value.filter(
    (row) => `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}-${row.fc_scode}` === scodeKey
  ).length;
};

// 삭제 가능 여부 확인 (연결 항목만 개별 삭제 불가)
const canDeleteRow = (item: ProcessedFinanceCode) => {
  // 연결된 항목(사회보험/퇴직금)은 개별 삭제 불가 (급여와 함께 삭제됨)
  if (item.isLinkedItem) {
    return false;
  }
  // 나머지 항목은 삭제 가능 (마지막 행이면 데이터만 초기화)
  return true;
};

// 삭제 대기 목록에 추가 (저장 시 실제 DB 삭제)
const addToPendingDelete = (hbIdx: number) => {
  if (hbIdx && !pendingDeleteIds.value.includes(hbIdx)) {
    pendingDeleteIds.value.push(hbIdx);
  }
};

// 행 데이터 초기화 (마지막 행일 때 사용)
const clearRowData = (item: ProcessedFinanceCode) => {
  // 삭제 대기 목록에 추가
  if (item.hb_idx) {
    addToPendingDelete(item.hb_idx);
  }
  // 데이터 초기화
  item.hb_idx = undefined;
  item.description = '';
  item.unit_price = '';
  item.count = '';
  item.months = '';
  item.hb_pay_rel = undefined;
  item.hb_pay_rel_manual = 'N';
  item.hb_revenue_rel = undefined;
  item.suga_rank = item.isRevenuePairItem ? '180분' : undefined;
  item.suga_times = item.isRevenuePairItem ? '20' : undefined;
};

// 급여 항목의 같은 scode 내 순서 인덱스 가져오기
const getSalaryIndexInScode = (item: ProcessedFinanceCode): number => {
  if (!item.isSalaryItem) return -1;
  const scodeKey = `${item.fc_trcode}-${item.fc_lcode}-${item.fc_mcode}-${item.fc_scode}`;
  const sameScodeItems = processedData.value.filter(
    row => `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}-${row.fc_scode}` === scodeKey && row.isSalaryItem
  );
  return sameScodeItems.findIndex(row => row === item);
};

// 순서 기반으로 연결된 사회보험/퇴직금 항목 찾기
const findLinkedItemsByOrder = (salaryItem: ProcessedFinanceCode): ProcessedFinanceCode[] => {
  const linkedItems: ProcessedFinanceCode[] = [];
  const salaryIndex = getSalaryIndexInScode(salaryItem);
  if (salaryIndex < 0) return linkedItems;
  
  const linkedScodes = getLinkedScodes(salaryItem.fc_scode);
  if (!linkedScodes) return linkedItems;
  
  // 사회보험 scode의 같은 순서 항목 찾기
  const insuranceScodeKey = `OUT-${linkedScodes.insurance}`;
  let insuranceCount = 0;
  for (const row of processedData.value) {
    if (row.fc_trcode === 'OUT' && row.fc_scode === linkedScodes.insurance && row.isLinkedItem) {
      if (insuranceCount === salaryIndex) {
        linkedItems.push(row);
        break;
      }
      insuranceCount++;
    }
  }
  
  // 퇴직금 scode의 같은 순서 항목 찾기
  let retirementCount = 0;
  for (const row of processedData.value) {
    if (row.fc_trcode === 'OUT' && row.fc_scode === linkedScodes.retirement && row.isLinkedItem) {
      if (retirementCount === salaryIndex) {
        linkedItems.push(row);
        break;
      }
      retirementCount++;
    }
  }
  
  return linkedItems;
};

// 순서 기반으로 수입 쌍 짝궁 찾기 (기존 getRevenuePairItem 사용)
// getRevenuePairItem 함수가 이미 순서 기반으로 동작함

// 행 삭제 또는 데이터 초기화 (저장 시 실제 DB 반영)
// - 마지막 행이면 데이터만 초기화
// - 급여 삭제 시 순서 기반으로 사회보험/퇴직금도 함께 삭제
// - 수입 쌍 삭제 시 순서 기반으로 짝도 함께 삭제
const deleteRow = (index: number) => {
  const item = processedData.value[index];
  
  // 연결 항목은 개별 삭제 불가
  if (item.isLinkedItem) {
    return;
  }
  
  const isLastRow = getSameScodeRowCount(item) === 1;
  
  // 1. 급여 항목인 경우: 연결된 사회보험/퇴직금도 함께 처리
  if (item.isSalaryItem) {
    // hb_pay_rel이 있으면 같은 키로 찾기, 없으면 순서 기반으로 찾기
    let linkedItems: ProcessedFinanceCode[] = [];
    
    if (item.hb_pay_rel) {
      linkedItems = processedData.value.filter(
        row => row.hb_pay_rel === item.hb_pay_rel && row !== item
      );
    } else {
      linkedItems = findLinkedItemsByOrder(item);
    }
    
    if (isLastRow) {
      // 마지막 행이면 데이터만 초기화
      clearRowData(item);
      // 연결된 항목들도 데이터 초기화
      for (const linkedItem of linkedItems) {
        const linkedIsLast = getSameScodeRowCount(linkedItem) === 1;
        if (linkedIsLast) {
          clearRowData(linkedItem);
        } else {
          // 연결 항목의 scode에 여러 행이 있으면 삭제
          if (linkedItem.hb_idx) {
            addToPendingDelete(linkedItem.hb_idx);
          }
          const linkedIndex = processedData.value.indexOf(linkedItem);
          if (linkedIndex >= 0) {
            processedData.value.splice(linkedIndex, 1);
          }
        }
      }
    } else {
      // 마지막 행이 아니면 삭제
      // 연결된 항목들 먼저 삭제 (역순으로)
      for (const linkedItem of linkedItems) {
        if (linkedItem.hb_idx) {
          addToPendingDelete(linkedItem.hb_idx);
        }
        const linkedIndex = processedData.value.indexOf(linkedItem);
        if (linkedIndex >= 0) {
          processedData.value.splice(linkedIndex, 1);
        }
      }
      // 급여 항목 삭제
      if (item.hb_idx) {
        addToPendingDelete(item.hb_idx);
      }
      // 인덱스가 변경되었을 수 있으므로 다시 찾기
      const currentIndex = processedData.value.indexOf(item);
      if (currentIndex >= 0) {
        processedData.value.splice(currentIndex, 1);
      }
    }
  }
  // 2. 수입 쌍(112/611) 항목인 경우: 짝도 함께 처리
  else if (isRevenuePairItem(item)) {
    // 순서 기반으로 짝 찾기
    const pairItem = getRevenuePairItem(item);
    
    if (isLastRow) {
      // 마지막 행이면 데이터만 초기화
      clearRowData(item);
      // 짝 항목도 처리
      if (pairItem) {
        const pairIsLast = getSameScodeRowCount(pairItem) === 1;
        if (pairIsLast) {
          clearRowData(pairItem);
        } else {
          if (pairItem.hb_idx) {
            addToPendingDelete(pairItem.hb_idx);
          }
          const pairIndex = processedData.value.indexOf(pairItem);
          if (pairIndex >= 0) {
            processedData.value.splice(pairIndex, 1);
          }
        }
      }
    } else {
      // 마지막 행이 아니면 삭제
      // 짝 항목 먼저 삭제
      if (pairItem) {
        if (pairItem.hb_idx) {
          addToPendingDelete(pairItem.hb_idx);
        }
        const pairIndex = processedData.value.indexOf(pairItem);
        if (pairIndex >= 0) {
          processedData.value.splice(pairIndex, 1);
        }
      }
      // 현재 항목 삭제
      if (item.hb_idx) {
        addToPendingDelete(item.hb_idx);
      }
      const currentIndex = processedData.value.indexOf(item);
      if (currentIndex >= 0) {
        processedData.value.splice(currentIndex, 1);
      }
    }
  }
  // 3. 일반 항목
  else {
    if (isLastRow) {
      // 마지막 행이면 데이터만 초기화
      clearRowData(item);
    } else {
      // 마지막 행이 아니면 삭제
      if (item.hb_idx) {
        addToPendingDelete(item.hb_idx);
      }
      processedData.value.splice(index, 1);
    }
  }
  
  // rowspan 재계산
  recalculateRowspans();
};

// 첫 예산 작성 폼 입력 핸들러
const onCaregiverCountInput = (event: any) => {
  const value = event.target.value.replace(/[^\d]/g, "");
  firstBudgetData.value.caregiverCount = value;
};

const onPatientCountInput = (event: any) => {
  const value = event.target.value.replace(/[^\d]/g, "");
  firstBudgetData.value.patientCount = value;
};

const onBudgetMonthsInput = (event: any) => {
  const value = event.target.value.replace(/[^\d]/g, "");
  if (value) {
    const num = parseInt(value);
    if (num > 12) {
      firstBudgetData.value.budgetMonths = "12";
    } else if (num < 1) {
      firstBudgetData.value.budgetMonths = "1";
    } else {
      firstBudgetData.value.budgetMonths = value;
    }
  } else {
    firstBudgetData.value.budgetMonths = "";
  }
};

const onSugaTimeChange = () => {
  // 수가 선택 변경 시 처리 (필요시)
};

// 현재 단계 유효성 검사
const isCurrentStepValid = computed(() => {
  switch (currentStep.value) {
    case 1:
      return firstBudgetData.value.patientCount && parseInt(firstBudgetData.value.patientCount) > 0;
    case 2:
      return firstBudgetData.value.caregiverCount && parseInt(firstBudgetData.value.caregiverCount) > 0;
    case 3:
      return firstBudgetData.value.selectedSugaTime !== "";
    case 4:
      return firstBudgetData.value.budgetMonths && parseInt(firstBudgetData.value.budgetMonths) > 0 && parseInt(firstBudgetData.value.budgetMonths) <= 12;
    default:
      return false;
  }
});

// 첫 예산 작성 폼 유효성 검사
const isFirstBudgetFormValid = computed(() => {
  return (
    firstBudgetData.value.caregiverCount &&
    parseInt(firstBudgetData.value.caregiverCount) > 0 &&
    firstBudgetData.value.patientCount &&
    parseInt(firstBudgetData.value.patientCount) > 0 &&
    firstBudgetData.value.selectedSugaTime &&
    firstBudgetData.value.budgetMonths &&
    parseInt(firstBudgetData.value.budgetMonths) > 0
  );
});

// 세입 예산 데이터 존재 여부 확인
const hasRevenueData = computed(() => {
  // processedData에서 세입(IN) 데이터 중 실제 예산이 입력된 행이 있는지 확인
  return processedData.value.some(item => {
    if (item.fc_trcode !== 'IN') return false;
    const unitPrice = Number(item.unit_price?.replace(/,/g, '') || 0);
    const count = Number(item.count?.replace(/,/g, '') || 0);
    const months = Number(item.months?.replace(/,/g, '') || 0);
    return unitPrice > 0 || count > 0 || months > 0;
  });
});

// 예산 스타터 화면 표시 여부
const showBudgetStarterPrompt = computed(() => {
  return !loading.value && !hasRevenueData.value;
});

// 추경차수 라벨
const budgetClassLabel = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return '본예산';
  return `${budClass}차 추경`;
});

// 추경차수 스타일
const budgetClassStyle = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return 'primary';
  return 'warning';
});

// 추경차수 아이콘
const budgetClassIcon = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return 'mdi-file-document-outline';
  return 'mdi-file-document-edit-outline';
});

// 연도 범위
const currentSystemYear = new Date().getFullYear();
const minYear = currentSystemYear - 2;
const maxYear = currentSystemYear + 1;

// 연도 변경 함수
const changeYear = (delta: number) => {
  const newYear = parseInt(searchParams.value.lebYear) + delta;
  if (newYear >= minYear && newYear <= maxYear) {
    searchParams.value.lebYear = newYear.toString();
    emit('year-change', searchParams.value.lebYear);
    fetchFinanceCodes();
  }
};

// 금액 포맷팅 함수
const formatMoney = (amount: number): string => {
  return new Intl.NumberFormat('ko-KR').format(amount);
};

// 세입 합계
const totalRevenue = computed(() => {
  let total = 0;
  processedData.value.forEach(item => {
    if (item.fc_trcode === 'IN') {
      total += getExactAmount(item);
    }
  });
  return total;
});

// 세출 합계
const totalExpense = computed(() => {
  let total = 0;
  processedData.value.forEach(item => {
    if (item.fc_trcode === 'OUT') {
      total += getExactAmount(item);
    }
  });
  return total;
});

// 잔액
const balance = computed(() => {
  return totalRevenue.value - totalExpense.value;
});

// 기준 인건비 비율 (props에서 가져오거나 기본값 60%)
const standardLaborCostRate = computed(() => {
  return props.taxData?.tr_labor_cost_rate || 60;
});

// 인건비 총액 계산 (직접비: 급여1111 + 사회보험1151 + 퇴직금1141)
const totalLaborCost = computed(() => {
  let total = 0;
  processedData.value.forEach(item => {
    // 직접비 급여, 사회보험, 퇴직금만 포함
    if (['1111', '1151', '1141'].includes(item.fc_scode)) {
      total += getExactAmount(item);
    }
  });
  return total;
});

// 인건비 비율 계산용 수입 (본인부담금112 + 장기요양급여611 + 가산금613)
const laborCostBaseRevenue = computed(() => {
  let total = 0;
  processedData.value.forEach(item => {
    if (['112', '611', '613'].includes(item.fc_scode)) {
      total += getExactAmount(item);
    }
  });
  return total;
});

// 현재 인건비 비율
const currentLaborCostRate = computed(() => {
  if (laborCostBaseRevenue.value === 0) return 0;
  return (totalLaborCost.value / laborCostBaseRevenue.value) * 100;
});

// 인건비 비율 기준 미달 여부
const isLaborCostBelowStandard = computed(() => {
  return currentLaborCostRate.value < standardLaborCostRate.value;
});

// 인건비 데이터 존재 여부 (급여 항목이 있는지 확인)
const hasLaborCostData = computed(() => {
  return processedData.value.some(item => 
    ['1111', '1112'].includes(item.fc_scode) && 
    item.description && 
    item.unit_price
  );
});

// 임직원보수일람표 모달 열기
const downloadPayrollList = () => {
  showPayExcelDialog.value = true;
};

// 희망이음 예산업로드 모달 열기
const downloadHopeExcel = () => {
  showHopeExcelDialog.value = true;
};

// 예산 삭제 함수
const deleteBudget = async () => {
  if (!store.state.user?.m_sisul_code) {
    console.error("시설 코드가 없습니다.");
    return;
  }

  deleting.value = true;
  try {
    const response = await axios.post("/api/budget/delete", {
      sisulCode: store.state.user.m_sisul_code,
      year: searchParams.value.lebYear,
      budClass: props.budgetClass || '' // 빈 문자열 = 본예산
    });

    if (response.data.success) {
      // 삭제 후 데이터 다시 조회
      showDeleteDialog.value = false;
      await fetchFinanceCodes();
      showSnackbar(`${searchParams.value.lebYear}년 ${budgetClassLabel.value} 예산이 삭제되었습니다.`, 'success');
    } else {
      console.error("예산 삭제 실패:", response.data.message);
      showSnackbar('예산 삭제에 실패했습니다.', 'error');
    }
  } catch (error) {
    console.error("예산 삭제 오류:", error);
    showSnackbar('예산 삭제 중 오류가 발생했습니다.', 'error');
  } finally {
    deleting.value = false;
  }
};

// 예산 작성 마법사 열기
const openBudgetWizard = () => {
  // Q&A 스타터 페이지로 이동
  emit('open-starter');
};

// 예산 작성 마법사 닫기
const closeBudgetWizard = () => {
  showBudgetWizard.value = false;
  currentStep.value = 1;
};

// 다음 단계
const nextStep = () => {
  if (currentStep.value < totalSteps && isCurrentStepValid.value) {
    currentStep.value++;
  }
};

// 이전 단계
const prevStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
};

// 첫 예산 생성
const createFirstBudget = async () => {
  if (!isFirstBudgetFormValid.value) {
    return;
  }

  saving.value = true;
  try {
    // TODO: 첫 예산 생성 로직 구현
    // 여기서 입력된 정보를 바탕으로 예산 데이터를 생성해야 함
    
    // 예시: 생성 후 데이터 다시 조회
    await fetchFinanceCodes();
    
    // 마법사 닫기
    closeBudgetWizard();
  } catch (error) {
    console.error("첫 예산 생성 오류:", error);
  } finally {
    saving.value = false;
  }
};

// 급여 인풋 포커스 시 그룹 활성화
const handleSalaryFocus = (item: ProcessedFinanceCode) => {
  if (item.isSalaryItem && item.hb_pay_rel) {
    focusedPayRelGroup.value = item.hb_pay_rel;
  }
};

// 급여 인풋 블러 시 그룹 비활성화
const handleSalaryBlur = () => {
  focusedPayRelGroup.value = null;
};

// 본인부담금-장기요양급여 포커스 시 쌍 그룹 활성화 (순서 기반, 세입만)
const handleRevenuePairFocus = (item: ProcessedFinanceCode) => {
  if (isRevenuePairItem(item)) {
    focusedRevenuePairItem.value = item;
  }
};

// 본인부담금-장기요양급여 블러 시 쌍 그룹 비활성화
const handleRevenuePairBlur = () => {
  focusedRevenuePairItem.value = null;
};

// 본인부담금/장기요양급여 scode 확인 (세입에서만 유효)
const isRevenuePairScode = (scode: string, trcode?: string): boolean => {
  // trcode가 제공되면 세입(IN)인지 확인
  if (trcode && trcode !== 'IN') return false;
  return REVENUE_PAIR_SCODES.includes(scode);
};

// 항목이 수입 쌍인지 확인 (trcode도 함께 체크)
const isRevenuePairItem = (item: ProcessedFinanceCode): boolean => {
  return item.fc_trcode === 'IN' && REVENUE_PAIR_SCODES.includes(item.fc_scode);
};

// 수가 선택에 따른 단가 계산
const calculateSugaUnitPrice = (item: ProcessedFinanceCode): number => {
  if (!item.suga_rank || !item.suga_times || !props.sugaList) return 0;
  
  const suga = props.sugaList.find(s => s.suga_rank === item.suga_rank);
  if (!suga) return 0;
  
  const times = Number(item.suga_times.replace(/,/g, '')) || 0;
  
  // 본인부담금(112): suga_bonin × 횟수
  // 장기요양급여수입(611): (suga_money - suga_bonin) × 횟수
  if (item.fc_scode === '112') {
    return suga.suga_bonin * times;
  } else if (item.fc_scode === '611') {
    return (suga.suga_money - suga.suga_bonin) * times;
  }
  
  return 0;
};

// 수가 선택 변경 시 처리 (본인부담금 ↔ 장기요양급여 자동 연동)
const handleSugaChange = (item: ProcessedFinanceCode) => {
  // 단가 계산
  const unitPrice = calculateSugaUnitPrice(item);
  item.unit_price = unitPrice > 0 ? unitPrice.toLocaleString() : '';
  
  // description 업데이트
  item.description = item.suga_rank && item.suga_times ? `${item.suga_rank} X ${item.suga_times}` : '';
  
  // 본인부담금(112) ↔ 장기요양급여(611) 자동 연동 (세입만)
  if (isRevenuePairItem(item)) {
    syncRevenuePairValues(item, 'suga_rank');
    syncRevenuePairValues(item, 'suga_times');
  }
};

// 수가 횟수 입력 변경 시 처리 (본인부담금 ↔ 장기요양급여 자동 연동)
const handleSugaTimesInput = (event: any, item: ProcessedFinanceCode) => {
  // 숫자만 허용
  const value = event.target.value.replace(/[^0-9]/g, '');
  item.suga_times = value;
  
  // 단가 재계산
  const unitPrice = calculateSugaUnitPrice(item);
  item.unit_price = unitPrice > 0 ? unitPrice.toLocaleString() : '';
  
  // description 업데이트
  item.description = item.suga_rank && item.suga_times ? `${item.suga_rank} X ${item.suga_times}` : '';
  
  // 본인부담금(112) ↔ 장기요양급여(611) 자동 연동 (세입만)
  if (isRevenuePairItem(item)) {
    syncRevenuePairValues(item, 'suga_times');
  }
};

// 본인부담금(112) 항목들의 인덱스 배열 가져오기
const getRevenue112Items = (): ProcessedFinanceCode[] => {
  return processedData.value.filter(row => row.fc_scode === '112');
};

// 장기요양급여(611) 항목들의 인덱스 배열 가져오기
const getRevenue611Items = (): ProcessedFinanceCode[] => {
  return processedData.value.filter(row => row.fc_scode === '611');
};

// 본인부담금/장기요양급여 항목의 순서(인덱스) 가져오기
const getRevenuePairIndex = (item: ProcessedFinanceCode): number => {
  if (item.fc_scode === '112') {
    return getRevenue112Items().findIndex(row => row === item);
  } else if (item.fc_scode === '611') {
    return getRevenue611Items().findIndex(row => row === item);
  }
  return -1;
};

// 짝궁 항목 가져오기 (순서 기반, 세입만)
const getRevenuePairItem = (item: ProcessedFinanceCode): ProcessedFinanceCode | null => {
  if (!isRevenuePairItem(item)) return null;
  
  const index = getRevenuePairIndex(item);
  if (index < 0) return null;
  
  const pairItems = item.fc_scode === '112' ? getRevenue611Items() : getRevenue112Items();
  return pairItems[index] || null;
};

// 포커스된 수입 쌍 정보 저장 (항목 자체 참조)
const focusedRevenuePairItem = ref<ProcessedFinanceCode | null>(null);

// 해당 행이 현재 포커스된 수입 쌍의 짝궁인지 확인
const isRevenuePairHighlighted = (item: ProcessedFinanceCode): boolean => {
  if (!focusedRevenuePairItem.value) return false;
  if (!isRevenuePairItem(item)) return false;
  
  // 포커스된 항목의 짝궁인지 확인
  const pairItem = getRevenuePairItem(focusedRevenuePairItem.value);
  return pairItem === item;
};

// 본인부담금-장기요양급여 쌍 항목의 count, months, suga_rank, suga_times 연동
// 순서 기반으로 연동 (112 N번째 ↔ 611 N번째)
const syncRevenuePairValues = (item: ProcessedFinanceCode, field: 'count' | 'months' | 'suga_rank' | 'suga_times') => {
  // 본인부담금(112) 또는 장기요양급여(611)인지 확인 (세입만)
  if (!isRevenuePairItem(item)) return;
  
  // 순서 기반으로 짝궁 찾기
  const pairItem = getRevenuePairItem(item);
  if (!pairItem) return;
  
  const newValue = item[field];
  
  // @ts-ignore - dynamic field assignment
  pairItem[field] = newValue;
  
  // suga_rank나 suga_times가 변경되면 unit_price도 재계산
  if (field === 'suga_rank' || field === 'suga_times') {
    const unitPrice = calculateSugaUnitPrice(pairItem);
    pairItem.unit_price = unitPrice > 0 ? unitPrice.toLocaleString() : '';
    pairItem.description = pairItem.suga_rank && pairItem.suga_times ? `${pairItem.suga_rank} X ${pairItem.suga_times}` : '';
  }
};

// 본인부담금-장기요양급여 입력 변경 핸들러
const handleRevenuePairInput = (event: any, item: ProcessedFinanceCode, field: string) => {
  // 기존 숫자 포맷팅 적용
  formatNumber(event, item, field);
  
  // 본인부담금/장기요양급여 항목이고 count나 months 변경 시 쌍 항목도 연동 (세입만)
  if (isRevenuePairItem(item) && (field === 'count' || field === 'months')) {
    syncRevenuePairValues(item, field as 'count' | 'months');
  }
};

// 급여 종류 변경 시 연결된 항목 description 업데이트 및 재계산
const handleSalaryTypeChange = async (salaryItem: ProcessedFinanceCode) => {
  if (!salaryItem.isSalaryItem) return;
  
  const salaryType = salaryItem.description || '';
  const isCeo = salaryType.includes('(대표자)');
  
  // 급여명 기본 부분 추출 (예: "센터장 급여" → "센터장", "사회복지사(대표자) 급여" → "사회복지사(대표자)")
  const baseName = salaryType.replace(' 급여', '');
  
  // 연결된 항목들의 description 업데이트 및 대표자 처리
  if (salaryItem.hb_pay_rel) {
    const payRelKey = salaryItem.hb_pay_rel;
    const linkedScodes = getLinkedScodes(salaryItem.fc_scode);
    
    if (isCeo && linkedScodes) {
      // 대표자인 경우: 퇴직금 행 삭제 (저장 시 실제 DB 반영)
      for (let i = processedData.value.length - 1; i >= 0; i--) {
        const item = processedData.value[i];
        if (item.hb_pay_rel === payRelKey && RETIREMENT_SCODES.includes(item.fc_scode)) {
          // 삭제 대기 목록에 추가
          if (item.hb_idx) {
            addToPendingDelete(item.hb_idx);
          }
          processedData.value.splice(i, 1);
        }
      }
    } else if (!isCeo && linkedScodes) {
      // 비대표자인 경우: 퇴직금 행이 없으면 생성
      const hasRetirement = processedData.value.some(
        item => item.hb_pay_rel === payRelKey && RETIREMENT_SCODES.includes(item.fc_scode)
      );
      
      if (!hasRetirement && store.state.user?.m_sisul_code) {
        // 퇴직금 행 INSERT
        const retirementResponse = await axios.post("/api/budget/insert", {
          sisulCode: store.state.user.m_sisul_code,
          year: searchParams.value.lebYear,
          budClass: props.budgetClass || '',
          trcode: 'OUT',
          scode: linkedScodes.retirement,
          payRel: payRelKey,
        });
        
        if (retirementResponse.data.success && retirementResponse.data.hb_idx) {
          const retirementFinanceCode = findFinanceCodeByScode('OUT', linkedScodes.retirement);
          
          const retirementRow: ProcessedFinanceCode = {
            fc_idx: retirementFinanceCode?.fc_idx || 0,
            fc_trcode: 'OUT',
            fc_trname: '세출',
            fc_year: salaryItem.fc_year,
            fc_lcode: retirementFinanceCode?.fc_lcode || '',
            fc_lname: retirementFinanceCode?.fc_lname || '',
            fc_mcode: retirementFinanceCode?.fc_mcode || '',
            fc_mname: retirementFinanceCode?.fc_mname || '',
            fc_scode: linkedScodes.retirement,
            fc_sname: retirementFinanceCode?.fc_sname || '퇴직금',
            fc_funding: retirementFinanceCode?.fc_funding || '',
            fc_funding_name: retirementFinanceCode?.fc_funding_name || '',
            hb_idx: retirementResponse.data.hb_idx,
            hb_pay_rel: payRelKey,
            hb_pay_rel_manual: 'N',
            hb_revenue_rel: undefined,
            budget_amount: "",
            description: `${baseName} 퇴직금`,
            unit_price: "",
            count: "",
            months: "",
            isAddedRow: true,
            isSalaryItem: false,
            isLinkedItem: true,
            isRevenuePairItem: false,
            showTrcode: false,
            showLcode: false,
            showMcode: false,
            showScode: false,
            trcodeRowspan: 0,
            lcodeRowspan: 0,
            mcodeRowspan: 0,
            scodeRowspan: 0,
          };
          
          // 퇴직금 scode 그룹의 마지막에 추가
          const retirementScodeKey = `${retirementRow.fc_trcode}-${retirementRow.fc_lcode}-${retirementRow.fc_mcode}-${retirementRow.fc_scode}`;
          let retirementInsertIndex = -1;
          for (let i = 0; i < processedData.value.length; i++) {
            const row = processedData.value[i];
            const rowScodeKey = `${row.fc_trcode}-${row.fc_lcode}-${row.fc_mcode}-${row.fc_scode}`;
            if (rowScodeKey === retirementScodeKey) {
              retirementInsertIndex = i;
            }
          }
          if (retirementInsertIndex >= 0) {
            processedData.value.splice(retirementInsertIndex + 1, 0, retirementRow);
          }
        }
      }
    }
    
    // 연결된 항목들의 description 업데이트
    processedData.value.forEach(item => {
      if (item.hb_pay_rel !== payRelKey) return;
      if (item.isSalaryItem) return; // 급여 자체는 제외
      
      const isInsurance = INSURANCE_SCODES.includes(item.fc_scode);
      const isRetirement = RETIREMENT_SCODES.includes(item.fc_scode);
      
      if (isInsurance) {
        item.description = `${baseName} 사회보험부담금`;
      } else if (isRetirement) {
        item.description = `${baseName} 퇴직금`;
      }
    });
    
    // rowspan 재계산
    recalculateRowspans();
    
    // 대표자 여부에 따라 재계산
    recalculateLinkedItems(salaryItem);
  }
};

// 대표자 여부 확인 헬퍼
const isCeoSalary = (item: ProcessedFinanceCode): boolean => {
  return !!item.isSalaryItem && (item.description || '').includes('(대표자)');
};

// 해당 행이 현재 포커스된 급여 그룹의 연결 항목인지 확인
const isLinkedHighlighted = (item: ProcessedFinanceCode): boolean => {
  if (!focusedPayRelGroup.value || !item.hb_pay_rel) return false;
  // 급여 항목이 아닌 연결된 항목만 하이라이트
  return item.hb_pay_rel === focusedPayRelGroup.value && !!item.isLinkedItem;
};

// 해당 행이 연결된 항목(수정 불가)인지 확인
// hb_pay_rel_manual='Y'이면 수동 편집 모드이므로 수정 가능
const isLinkedReadonly = (item: ProcessedFinanceCode): boolean => {
  return !!item.isLinkedItem && item.hb_pay_rel_manual !== 'Y';
};

// 잠금 해제 토글
const toggleManualEdit = (item: ProcessedFinanceCode) => {
  if (!item.isLinkedItem) return;
  
  if (item.hb_pay_rel_manual === 'Y') {
    // 수동 → 자동으로 전환: 현재 수동 입력 값을 저장
    item.manual_saved_unit_price = item.unit_price;
    item.manual_saved_count = item.count;
    item.manual_saved_months = item.months;
    item.hb_pay_rel_manual = 'N';
    
    // 자동계산 모드로 전환 시 연결된 급여 기반으로 재계산
    if (item.hb_pay_rel) {
      const salaryItem = processedData.value.find(
        row => row.hb_pay_rel === item.hb_pay_rel && row.isSalaryItem
      );
      if (salaryItem) {
        recalculateLinkedItems(salaryItem);
      }
    }
  } else {
    // 자동 → 수동으로 전환: 저장된 수동 입력 값이 있으면 복원
    item.hb_pay_rel_manual = 'Y';
    if (item.manual_saved_unit_price !== undefined) {
      item.unit_price = item.manual_saved_unit_price;
    }
    if (item.manual_saved_count !== undefined) {
      item.count = item.manual_saved_count;
    }
    if (item.manual_saved_months !== undefined) {
      item.months = item.manual_saved_months;
    }
  }
};

// 급여 변경 시 연결된 사회보험/퇴직금 자동 재계산
const recalculateLinkedItems = (salaryItem: ProcessedFinanceCode) => {
  if (!salaryItem.hb_pay_rel || !salaryItem.isSalaryItem) return;
  if (!props.taxData) return;
  
  const payRelId = salaryItem.hb_pay_rel;
  
  // 대표자 여부 확인
  const isCeo = (salaryItem.description || '').includes('(대표자)');
  
  // 급여 정보 계산 (1인당 단가 기준)
  const unitPrice = Number(salaryItem.unit_price?.replace(/,/g, "") || 0);
  const count = Number(salaryItem.count?.replace(/,/g, "") || 0);
  const months = Number(salaryItem.months?.replace(/,/g, "") || 0);
  
  // 연결된 사회보험/퇴직금 항목 찾아서 재계산
  processedData.value.forEach(item => {
    if (item.hb_pay_rel !== payRelId) return;
    if (item.isSalaryItem) return; // 급여 자체는 제외
    
    // 수동 편집 모드('Y')인 항목은 자동 재계산 제외
    if (item.hb_pay_rel_manual === 'Y') return;
    
    const isInsurance = INSURANCE_SCODES.includes(item.fc_scode);
    const isRetirement = RETIREMENT_SCODES.includes(item.fc_scode);
    
    if (isInsurance && props.taxData) {
      // 사회보험부담금 계산 (1인당 기준)
      const nationalPension = Math.round(unitPrice * (props.taxData.tr_yeon || 0));
      const healthInsurance = Math.round(unitPrice * (props.taxData.tr_gun || 0));
      const longTermCare = Math.round(healthInsurance * (props.taxData.tr_jang || 0));
      
      // 대표자인 경우 고용보험, 실업급여, 산재보험 제외
      const employmentInsurance = isCeo ? 0 : Math.round(unitPrice * (props.taxData.tr_go || 0));
      const unemployment = isCeo ? 0 : Math.round(unitPrice * (props.taxData.tr_sil || 0));
      const industrialAccident = isCeo ? 0 : Math.round(unitPrice * (props.taxData.tr_san || 0));
      
      // 1인당 월 사회보험부담금
      const perPersonInsurance = nationalPension + healthInsurance + longTermCare + 
                                 employmentInsurance + unemployment + industrialAccident;
      
      item.unit_price = perPersonInsurance.toLocaleString();
      item.count = count.toLocaleString(); // 급여의 명(회)와 동일
      item.months = months.toLocaleString(); // 급여의 개월과 동일
    } else if (isRetirement) {
      // 대표자인 경우 퇴직금 0원, 아니면 1인당 월 퇴직금 (급여의 1/12)
      const perPersonRetirement = isCeo ? 0 : Math.round(unitPrice / 12);
      
      item.unit_price = perPersonRetirement.toLocaleString();
      item.count = count.toLocaleString(); // 급여의 명(회)와 동일
      item.months = months.toLocaleString(); // 급여의 개월과 동일
    }
  });
};

// 급여 입력 변경 핸들러 (자동 재계산 트리거)
const handleSalaryInput = (event: any, item: ProcessedFinanceCode, field: string) => {
  // 기존 숫자 포맷팅 적용
  formatNumber(event, item, field);
  
  // 급여 항목이면 연결된 사회보험/퇴직금 재계산
  if (item.isSalaryItem && item.hb_pay_rel) {
    recalculateLinkedItems(item);
  }
};

// props.year 변경 시 동기화
watch(() => props.year, (newYear) => {
  if (newYear && newYear !== searchParams.value.lebYear) {
    searchParams.value.lebYear = newYear;
  }
}, { immediate: true });

// 연도 또는 구분 변경 시 자동 조회 및 emit
watch([() => searchParams.value.lebYear, selectedTrcode], ([newYear], [oldYear]) => {
  // 연도가 변경되었으면 emit
  if (newYear !== oldYear) {
    emit('year-change', searchParams.value.lebYear);
  }
  fetchFinanceCodes();
});

// 초기 로드
onMounted(async () => {
  await fetchFinanceCodes();
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (initialLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "48",
              width: "4"
            }),
            _cache[25] || (_cache[25] = _createElementVNode("p", null, "예산 데이터를 불러오는 중...", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "content-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["budget-layout", { 'sidebar-right': sidebarPosition.value === 'right' }])
        }, [
          (hasRevenueData.value)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_4, [
                _createElementVNode("button", {
                  class: "sidebar-position-toggle",
                  onClick: toggleSidebarPosition,
                  title: sidebarPosition.value === 'left' ? '우측으로 이동' : '좌측으로 이동'
                }, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(sidebarPosition.value === 'left' ? 'mdi-arrow-right' : 'mdi-arrow-left'), 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_5),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "year-nav-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeYear(-1))),
                    disabled: parseInt(searchParams.value.lebYear) <= minYear
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(searchParams.value.lebYear), 1),
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "year-unit" }, "년", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "year-nav-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (changeYear(1))),
                    disabled: parseInt(searchParams.value.lebYear) >= maxYear
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_10)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["sidebar-budget-class", budgetClassStyle.value])
                }, [
                  _createVNode(_component_v_icon, { size: "12" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(budgetClassIcon.value), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(budgetClassLabel.value), 1)
                ], 2),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      color: "#64748b"
                    }, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode("mdi-filter-variant", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[30] || (_cache[30] = _createElementVNode("span", null, "필터", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["filter-btn", { active: selectedTrcode.value === 'ALL' }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {selectedTrcode.value = 'ALL'; fetchFinanceCodes()})
                    }, "전체", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["filter-btn revenue", { active: selectedTrcode.value === 'IN' }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {selectedTrcode.value = 'IN'; fetchFinanceCodes()})
                    }, "세입", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["filter-btn expense", { active: selectedTrcode.value === 'OUT' }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {selectedTrcode.value = 'OUT'; fetchFinanceCodes()})
                    }, "세출", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "summary-header" }, [
                      _createElementVNode("span", { class: "dot" }),
                      _createElementVNode("span", { class: "label" }, "세입")
                    ], -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(formatMoney(totalRevenue.value)) + "원", 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "summary-header" }, [
                      _createElementVNode("span", { class: "dot" }),
                      _createElementVNode("span", { class: "label" }, "세출")
                    ], -1)),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(formatMoney(totalExpense.value)) + "원", 1)
                  ]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["summary-item balance", { warning: balance.value !== 0 }])
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: balance.value === 0 ? '#10b981' : '#ef4444'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(balance.value === 0 ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "잔액", -1))
                    ]),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(formatMoney(balance.value)) + "원", 1)
                  ], 2)
                ]),
                (totalExpense.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          color: "#374151"
                        }, {
                          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                            _createTextVNode("mdi-account-cash", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[36] || (_cache[36] = _createElementVNode("span", null, "인건비 비율", -1))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "labor-cost-label" }, "기준", -1)),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(standardLaborCostRate.value) + "%", 1)
                        ]),
                        _createVNode(_component_v_tooltip, {
                          location: "bottom",
                          "max-width": "280"
                        }, {
                          activator: _withCtx(({ props: tooltipProps }) => [
                            _createElementVNode("div", _mergeProps(tooltipProps, {
                              class: ["labor-cost-item current", { warning: isLaborCostBelowStandard.value, safe: !isLaborCostBelowStandard.value }]
                            }), [
                              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "labor-cost-label" }, "현재", -1)),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(currentLaborCostRate.value.toFixed(1)) + "%", 1)
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "tooltip-title" }, "산출근거", -1)),
                              _createElementVNode("div", _hoisted_28, [
                                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "tooltip-label" }, "인건비 지출", -1)),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(formatMoney(totalLaborCost.value)) + "원", 1)
                              ]),
                              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "tooltip-note" }, "(요양보호사·사회복지사 급여+보험+퇴직금)", -1)),
                              _createElementVNode("div", _hoisted_30, [
                                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "tooltip-label" }, "수입", -1)),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(formatMoney(laborCostBaseRevenue.value)) + "원", 1)
                              ]),
                              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "tooltip-note" }, "(장기요양급여+본인부담금+가산금)", -1)),
                              _createElementVNode("div", _hoisted_32, " 비율 = " + _toDisplayString(formatMoney(totalLaborCost.value)) + " ÷ " + _toDisplayString(formatMoney(laborCostBaseRevenue.value)) + " × 100 = " + _toDisplayString(currentLaborCostRate.value.toFixed(1)) + "% ", 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["labor-cost-status", { warning: isLaborCostBelowStandard.value }])
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "12",
                          color: isLaborCostBelowStandard.value ? '#ef4444' : '#10b981'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isLaborCostBelowStandard.value ? 'mdi-alert' : 'mdi-check-circle'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        (isLaborCostBelowStandard.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "기준 미달"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_34, "기준 충족"))
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "action-btn save",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showSaveConfirmDialog.value = true)),
                    disabled: saving.value
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-content-save", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(saving.value ? '저장 중...' : '저장'), 1)
                  ], 8, _hoisted_36),
                  _createElementVNode("button", {
                    class: "action-btn delete",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showDeleteDialog.value = true))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                        _createTextVNode("mdi-delete", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[46] || (_cache[46] = _createElementVNode("span", null, "삭제", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      color: "#64748b"
                    }, {
                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                        _createTextVNode("mdi-file-excel", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[48] || (_cache[48] = _createElementVNode("span", null, "엑셀 다운로드", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "action-btn excel",
                    onClick: downloadPayrollList,
                    disabled: !hasLaborCostData.value
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                        _createTextVNode("mdi-download", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[50] || (_cache[50] = _createElementVNode("span", null, "임직원보수일람표", -1))
                  ], 8, _hoisted_39),
                  _createElementVNode("button", {
                    class: "action-btn excel hope",
                    onClick: downloadHopeExcel,
                    disabled: processedData.value.length === 0
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                        _createTextVNode("mdi-download", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[52] || (_cache[52] = _createElementVNode("span", null, "예산(산출근거포함)", -1))
                  ], 8, _hoisted_40)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(PgmBudgetPayExcel, {
            modelValue: showPayExcelDialog.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showPayExcelDialog).value = $event)),
            year: searchParams.value.lebYear,
            "budget-data": processedData.value,
            "tax-data": props.taxData,
            "biz-gubun": _unref(store).state.user?.m_sisul_gubun,
            onShowSnackbar: _cache[8] || (_cache[8] = (msg, type) => showSnackbar(msg, type as 'success' | 'error' | 'warning' | 'info'))
          }, null, 8, ["modelValue", "year", "budget-data", "tax-data", "biz-gubun"]),
          _createVNode(PgmBudgetHopeExcel, {
            modelValue: showHopeExcelDialog.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showHopeExcelDialog).value = $event)),
            year: searchParams.value.lebYear,
            "budget-data": processedData.value,
            "biz-gubun": _unref(store).state.user?.m_sisul_gubun,
            onShowSnackbar: _cache[10] || (_cache[10] = (msg, type) => showSnackbar(msg, type as 'success' | 'error' | 'warning' | 'info'))
          }, null, 8, ["modelValue", "year", "budget-data", "biz-gubun"]),
          _createElementVNode("main", {
            class: _normalizeClass(["budget-main-content", { 'full-width': !hasRevenueData.value }])
          }, [
            _createVNode(_component_v_card, { class: "table-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "table-card-text" }, {
                  default: _withCtx(() => [
                    (showBudgetStarterPrompt.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createVNode(_component_v_icon, {
                            size: "64",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                              _createTextVNode("mdi-file-document-edit-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_42, _toDisplayString(searchParams.value.lebYear) + "년 예산 데이터가 없습니다", 1),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "x-large",
                            variant: "elevated",
                            onClick: openBudgetWizard,
                            class: "create-budget-btn"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "24" }, {
                                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                  _createTextVNode("mdi-plus-circle", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[55] || (_cache[55] = _createElementVNode("span", { class: "ml-2" }, "예산 작성하기", -1))
                            ]),
                            _: 1
                          })
                        ]))
                      : (!loading.value && processedData.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("table", _hoisted_44, [
                              _cache[59] || (_cache[59] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "구분"),
                                  _createElementVNode("th", null, "관"),
                                  _createElementVNode("th", null, "항"),
                                  _createElementVNode("th", null, "목"),
                                  _createElementVNode("th", null, "내용"),
                                  _createElementVNode("th", null, "단가"),
                                  _createElementVNode("th", null, "명(회)"),
                                  _createElementVNode("th", null, "개월"),
                                  _createElementVNode("th", null, "금액"),
                                  _createElementVNode("th", null, "자금원천"),
                                  _createElementVNode("th", null, "기능")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedData.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    (item.showTrcode)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 0,
                                          rowspan: item.trcodeRowspan,
                                          class: _normalizeClass(['trcode-cell', item.fc_trcode === 'IN' ? 'income' : 'expense'])
                                        }, _toDisplayString(item.fc_trname), 11, _hoisted_45))
                                      : _createCommentVNode("", true),
                                    (item.showLcode)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 1,
                                          rowspan: item.lcodeRowspan,
                                          class: _normalizeClass(['lcode-cell', item.fc_trcode === 'IN' ? 'income' : 'expense'])
                                        }, [
                                          _createElementVNode("div", _hoisted_47, _toDisplayString(item.fc_lname), 1),
                                          (getLcodeBudgetSum(item) > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(formatMoney(getLcodeBudgetSum(item))) + "원 ", 1))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_46))
                                      : _createCommentVNode("", true),
                                    (item.showMcode)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 2,
                                          rowspan: item.mcodeRowspan,
                                          class: "mcode-cell"
                                        }, [
                                          _createElementVNode("div", _hoisted_50, _toDisplayString(item.fc_mname), 1),
                                          (getMcodeBudgetSum(item) > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(formatMoney(getMcodeBudgetSum(item))) + "원 ", 1))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_49))
                                      : _createCommentVNode("", true),
                                    (item.showScode)
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 3,
                                          rowspan: item.scodeRowspan,
                                          class: "scode-cell"
                                        }, [
                                          _createElementVNode("div", _hoisted_53, _toDisplayString(item.fc_sname), 1),
                                          (getScodeBudgetSum(item) > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(formatMoney(getScodeBudgetSum(item))) + "원", 1))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_52))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_55, [
                                      (item.isSalaryItem)
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 0,
                                            "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                                            class: _normalizeClass(["salary-select", { 'linked-highlight': isLinkedHighlighted(item) }]),
                                            onChange: ($event: any) => (handleSalaryTypeChange(item)),
                                            onFocus: ($event: any) => (handleSalaryFocus(item)),
                                            onBlur: _cache[11] || (_cache[11] = ($event: any) => (handleSalaryBlur()))
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSalaryOptions(item.fc_scode), (opt) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: opt.value,
                                                value: opt.value
                                              }, _toDisplayString(opt.label), 9, _hoisted_57))
                                            }), 128))
                                          ], 42, _hoisted_56)), [
                                            [_vModelSelect, item.description]
                                          ])
                                        : (isRevenuePairItem(item))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                              _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": ($event: any) => ((item.suga_rank) = $event),
                                                class: _normalizeClass(["suga-select", { 'revenue-pair-highlight': isRevenuePairHighlighted(item) }]),
                                                onChange: ($event: any) => (handleSugaChange(item)),
                                                onFocus: ($event: any) => (handleRevenuePairFocus(item)),
                                                onBlur: _cache[12] || (_cache[12] = ($event: any) => (handleRevenuePairBlur()))
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sugaList, (suga) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: suga.suga_idx,
                                                    value: suga.suga_rank
                                                  }, _toDisplayString(suga.suga_rank), 9, _hoisted_60))
                                                }), 128))
                                              ], 42, _hoisted_59), [
                                                [_vModelSelect, item.suga_rank]
                                              ]),
                                              _cache[56] || (_cache[56] = _createElementVNode("span", { class: "suga-multiply" }, "×", -1)),
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": ($event: any) => ((item.suga_times) = $event),
                                                class: _normalizeClass(["suga-times-input", { 'revenue-pair-highlight': isRevenuePairHighlighted(item) }]),
                                                onInput: ($event: any) => (handleSugaTimesInput($event, item)),
                                                onFocus: ($event: any) => (handleRevenuePairFocus(item)),
                                                onBlur: _cache[13] || (_cache[13] = ($event: any) => (handleRevenuePairBlur()))
                                              }, null, 42, _hoisted_61), [
                                                [_vModelText, item.suga_times]
                                              ])
                                            ]))
                                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                                              key: 2,
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                                              class: _normalizeClass(["description-input", { 
                        'readonly-input': item.isLinkedItem,
                        'linked-highlight': isLinkedHighlighted(item)
                      }]),
                                              disabled: item.isLinkedItem
                                            }, null, 10, _hoisted_62)), [
                                              [_vModelText, item.description]
                                            ])
                                    ]),
                                    _createElementVNode("td", _hoisted_63, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((item.unit_price) = $event),
                                        class: _normalizeClass(["number-input", { 
                        'readonly-input': isLinkedReadonly(item) || isRevenuePairItem(item),
                        'linked-highlight': isLinkedHighlighted(item),
                        'revenue-pair-highlight': isRevenuePairHighlighted(item),
                        'manual-edit-input': item.isLinkedItem && item.hb_pay_rel_manual === 'Y'
                      }]),
                                        disabled: isLinkedReadonly(item) || isRevenuePairItem(item),
                                        onInput: ($event: any) => (item.isSalaryItem ? handleSalaryInput($event, item, 'unit_price') : formatNumber($event, item, 'unit_price')),
                                        onFocus: ($event: any) => (item.isSalaryItem ? handleSalaryFocus(item) : (isRevenuePairItem(item) && handleRevenuePairFocus(item))),
                                        onBlur: ($event: any) => (item.isSalaryItem ? handleSalaryBlur() : (isRevenuePairItem(item) && handleRevenuePairBlur()))
                                      }, null, 42, _hoisted_64), [
                                        [_vModelText, item.unit_price]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_65, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((item.count) = $event),
                                        class: _normalizeClass(["number-input", { 
                        'readonly-input': isLinkedReadonly(item),
                        'linked-highlight': isLinkedHighlighted(item),
                        'revenue-pair-highlight': isRevenuePairHighlighted(item),
                        'manual-edit-input': item.isLinkedItem && item.hb_pay_rel_manual === 'Y'
                      }]),
                                        disabled: isLinkedReadonly(item),
                                        onInput: ($event: any) => (item.isSalaryItem ? handleSalaryInput($event, item, 'count') : (isRevenuePairItem(item) ? handleRevenuePairInput($event, item, 'count') : formatNumber($event, item, 'count'))),
                                        onFocus: ($event: any) => (item.isSalaryItem ? handleSalaryFocus(item) : (isRevenuePairItem(item) && handleRevenuePairFocus(item))),
                                        onBlur: ($event: any) => (item.isSalaryItem ? handleSalaryBlur() : (isRevenuePairItem(item) && handleRevenuePairBlur()))
                                      }, null, 42, _hoisted_66), [
                                        [_vModelText, item.count]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_67, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((item.months) = $event),
                                        class: _normalizeClass(["number-input", { 
                        'readonly-input': isLinkedReadonly(item),
                        'linked-highlight': isLinkedHighlighted(item),
                        'revenue-pair-highlight': isRevenuePairHighlighted(item),
                        'manual-edit-input': item.isLinkedItem && item.hb_pay_rel_manual === 'Y'
                      }]),
                                        disabled: isLinkedReadonly(item),
                                        onInput: ($event: any) => (item.isSalaryItem ? handleSalaryInput($event, item, 'months') : (isRevenuePairItem(item) ? handleRevenuePairInput($event, item, 'months') : formatNumber($event, item, 'months'))),
                                        onFocus: ($event: any) => (item.isSalaryItem ? handleSalaryFocus(item) : (isRevenuePairItem(item) && handleRevenuePairFocus(item))),
                                        onBlur: ($event: any) => (item.isSalaryItem ? handleSalaryBlur() : (isRevenuePairItem(item) && handleRevenuePairBlur()))
                                      }, null, 42, _hoisted_68), [
                                        [_vModelText, item.months]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_69, _toDisplayString(calculateAmount(item)), 1),
                                    _createElementVNode("td", _hoisted_70, _toDisplayString(item.fc_funding_name || item.fc_funding || '-'), 1),
                                    _createElementVNode("td", _hoisted_71, [
                                      (item.isLinkedItem)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _createVNode(_component_v_switch, {
                                              "model-value": item.hb_pay_rel_manual === 'Y',
                                              "onUpdate:modelValue": ($event: any) => (toggleManualEdit(item)),
                                              density: "compact",
                                              "hide-details": "",
                                              color: "warning",
                                              class: "manual-switch"
                                            }, {
                                              label: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_73, _toDisplayString(item.hb_pay_rel_manual === 'Y' ? '수동' : '자동'), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["model-value", "onUpdate:modelValue"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                            _createVNode(_component_v_btn, {
                                              icon: "",
                                              size: "x-small",
                                              variant: "text",
                                              color: "primary",
                                              onClick: _withModifiers(($event: any) => (addRow(index)), ["stop"]),
                                              class: "add-btn"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                  default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                                    _createTextVNode("mdi-plus", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              icon: "",
                                              size: "x-small",
                                              variant: "text",
                                              color: "error",
                                              onClick: _withModifiers(($event: any) => (deleteRow(index)), ["stop"]),
                                              disabled: !canDeleteRow(item),
                                              class: "delete-btn"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                  default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                                    _createTextVNode("mdi-delete", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick", "disabled"])
                                          ]))
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (loading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                              _createVNode(_component_v_progress_circular, {
                                indeterminate: "",
                                color: "primary"
                              }),
                              _cache[60] || (_cache[60] = _createElementVNode("p", null, "데이터를 불러오는 중입니다...", -1))
                            ]))
                          : (selectedTrcode.value === 'OUT')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createVNode(_component_v_icon, {
                                  size: "48",
                                  color: "grey"
                                }, {
                                  default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                                    _createTextVNode("mdi-database-alert", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[62] || (_cache[62] = _createElementVNode("p", null, "조회할 데이터가 없습니다.", -1))
                              ]))
                            : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2)
        ], 2), [
          [_vShow, !initialLoading.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showBudgetWizard.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showBudgetWizard).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "budget-wizard-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "wizard-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_v_icon, {
                    size: "28",
                    color: "primary",
                    class: "wizard-icon"
                  }, {
                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                      _createTextVNode("mdi-file-document-edit", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("h3", { class: "wizard-title" }, "예산 작성하기", -1)),
                    _createElementVNode("p", _hoisted_78, "단계 " + _toDisplayString(currentStep.value) + " / " + _toDisplayString(totalSteps), 1)
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  onClick: closeBudgetWizard,
                  class: "close-wizard-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "20" }, {
                      default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "wizard-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    style: _normalizeStyle({ width: `${(currentStep.value / totalSteps) * 100}%` })
                  }, null, 4)
                ]),
                (currentStep.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                            _createTextVNode("mdi-account-heart", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[67] || (_cache[67] = _createElementVNode("h4", { class: "step-question" }, "수급자는 몇 명인가요?", -1)),
                      _cache[68] || (_cache[68] = _createElementVNode("p", { class: "step-description" }, "예산 작성을 위해 수급자 수를 입력해주세요.", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: firstBudgetData.value.patientCount,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((firstBudgetData.value.patientCount) = $event)),
                        type: "number",
                        variant: "outlined",
                        density: "comfortable",
                        placeholder: "수급자 수를 입력하세요",
                        min: "1",
                        "hide-details": "",
                        class: "step-input",
                        onInput: onPatientCountInput
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (currentStep.value === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                            _createTextVNode("mdi-account-group", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[70] || (_cache[70] = _createElementVNode("h4", { class: "step-question" }, "요양보호사는 몇 명인가요?", -1)),
                      _cache[71] || (_cache[71] = _createElementVNode("p", { class: "step-description" }, "예산 작성을 위해 요양보호사 수를 입력해주세요.", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: firstBudgetData.value.caregiverCount,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((firstBudgetData.value.caregiverCount) = $event)),
                        type: "number",
                        variant: "outlined",
                        density: "comfortable",
                        placeholder: "요양보호사 수를 입력하세요",
                        min: "1",
                        "hide-details": "",
                        class: "step-input",
                        onInput: onCaregiverCountInput
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (currentStep.value === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                            _createTextVNode("mdi-clock-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[74] || (_cache[74] = _createElementVNode("h4", { class: "step-question" }, "수가 평균을 선택해주세요", -1)),
                      _cache[75] || (_cache[75] = _createElementVNode("p", { class: "step-description" }, "예산 작성을 위해 수가 평균을 선택해주세요.", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((firstBudgetData.value.selectedSugaTime) = $event)),
                        onChange: onSugaTimeChange,
                        class: "suga-time-select"
                      }, [
                        _cache[73] || (_cache[73] = _createElementVNode("option", { value: "" }, "시간을 선택하세요", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sugaList, (suga) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: suga.suga_idx,
                            value: suga.suga_rank
                          }, _toDisplayString(suga.suga_rank) + " - " + _toDisplayString(formatMoney(Number(suga.suga_money))) + "원 ", 9, _hoisted_86))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, firstBudgetData.value.selectedSugaTime]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (currentStep.value === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                            _createTextVNode("mdi-calendar-month", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[77] || (_cache[77] = _createElementVNode("h4", { class: "step-question" }, "예산 개월 수를 입력해주세요", -1)),
                      _cache[78] || (_cache[78] = _createElementVNode("p", { class: "step-description" }, "예산 작성을 위해 예산 개월 수를 입력해주세요. (1~12개월)", -1)),
                      _createVNode(_component_v_text_field, {
                        modelValue: firstBudgetData.value.budgetMonths,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((firstBudgetData.value.budgetMonths) = $event)),
                        type: "number",
                        variant: "outlined",
                        density: "comfortable",
                        placeholder: "예산 개월 수를 입력하세요",
                        min: "1",
                        max: "12",
                        "hide-details": "",
                        class: "step-input",
                        onInput: onBudgetMonthsInput
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "wizard-actions" }, {
              default: _withCtx(() => [
                (currentStep.value > 1)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      onClick: prevStep,
                      class: "wizard-btn prev-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                            _createTextVNode("mdi-chevron-left", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[80] || (_cache[80] = _createElementVNode("span", { class: "ml-1" }, "이전", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                (currentStep.value < totalSteps)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      color: "primary",
                      variant: "elevated",
                      onClick: nextStep,
                      disabled: !isCurrentStepValid.value,
                      class: "wizard-btn next-btn"
                    }, {
                      default: _withCtx(() => [
                        _cache[82] || (_cache[82] = _createElementVNode("span", { class: "mr-1" }, "다음", -1)),
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "primary",
                      variant: "elevated",
                      onClick: createFirstBudget,
                      disabled: !isFirstBudgetFormValid.value,
                      loading: saving.value,
                      class: "wizard-btn submit-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                            _createTextVNode("mdi-check", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[84] || (_cache[84] = _createElementVNode("span", { class: "ml-1" }, "예산 생성하기", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showDeleteDialog).value = $event)),
      "max-width": "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "delete-dialog-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "delete-dialog-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "error",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[86] || (_cache[86] = _createElementVNode("span", null, "예산 삭제 확인", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "delete-dialog-content" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_89, [
                  _createElementVNode("strong", null, _toDisplayString(searchParams.value.lebYear) + "년 " + _toDisplayString(budgetClassLabel.value), 1),
                  _cache[87] || (_cache[87] = _createTextVNode(" 예산 데이터를 삭제하시겠습니까? ", -1))
                ]),
                _cache[88] || (_cache[88] = _createElementVNode("p", { class: "delete-notice" }, " 삭제된 예산은 복구할 수 없습니다. ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "delete-dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (showDeleteDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "elevated",
                  onClick: deleteBudget,
                  loading: deleting.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                        _createTextVNode("mdi-delete", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[91] || (_cache[91] = _createElementVNode("span", { class: "ml-1" }, "삭제", -1))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showSaveConfirmDialog.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((showSaveConfirmDialog).value = $event)),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "save-confirm-dialog-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "save-confirm-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "primary",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                    _createTextVNode("mdi-content-save", -1)
                  ]))]),
                  _: 1
                }),
                _cache[93] || (_cache[93] = _createElementVNode("span", null, "저장 확인", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "save-confirm-content" }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(searchParams.value.lebYear) + "년 " + _toDisplayString(budgetClassLabel.value) + " 예산을 저장하시겠습니까?", 1),
                (pendingDeleteIds.value.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_90, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "warning",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                          _createTextVNode("mdi-alert", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 삭제 대기 중인 항목 " + _toDisplayString(pendingDeleteIds.value.length) + "개가 함께 삭제됩니다. ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "save-confirm-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (showSaveConfirmDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "elevated",
                  onClick: confirmSave,
                  loading: saving.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[97] || (_cache[97] = _createElementVNode("span", { class: "ml-1" }, "저장", -1))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: snackbar.value.timeout,
      location: "top"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
            _createTextVNode(" 닫기 ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createVNode(_component_v_icon, {
            size: "20",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(snackbar.value.icon), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(snackbar.value.message), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"])
  ]))
}
}

})